import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CalendarDay: any;
  DateTime: any;
  JSON: any;
  Upload: any;
};

export type AccountNumberEntry = {
  __typename?: 'AccountNumberEntry';
  accountNumberEntryRequired?: Maybe<Scalars['Boolean']>;
  accountNumberLabel?: Maybe<Scalars['String']>;
  accountNumberLength?: Maybe<Scalars['Int']>;
  includeAccountNumberEntry?: Maybe<Scalars['Boolean']>;
  utilityBillExampleImage?: Maybe<Scalars['String']>;
};

export type AddressSelectionConfig = {
  __typename?: 'AddressSelectionConfig';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AuthenticatedItem = User;

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilter>;
};

export type CalendarDayNullableFilter = {
  equals?: InputMaybe<Scalars['CalendarDay']>;
  gt?: InputMaybe<Scalars['CalendarDay']>;
  gte?: InputMaybe<Scalars['CalendarDay']>;
  in?: InputMaybe<Array<Scalars['CalendarDay']>>;
  lt?: InputMaybe<Scalars['CalendarDay']>;
  lte?: InputMaybe<Scalars['CalendarDay']>;
  not?: InputMaybe<CalendarDayNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['CalendarDay']>>;
};

export type ChargeForecastConfig = {
  __typename?: 'ChargeForecastConfig';
  subtitle: Scalars['String'];
};

export type ColorSchemeConfig = {
  __typename?: 'ColorSchemeConfig';
  accentColor?: Maybe<Scalars['String']>;
  accentSubtleColor?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  primarySubtleColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  secondarySubtleColor?: Maybe<Scalars['String']>;
};

export type CreateInitialUserInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type DashboardConfig = {
  __typename?: 'DashboardConfig';
  alertHeaderContent?: Maybe<Scalars['String']>;
  chargerAlertHeaderContent?: Maybe<Scalars['String']>;
  thermostatAlertHeaderContent?: Maybe<Scalars['String']>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DisabledDevicesConfig = {
  __typename?: 'DisabledDevicesConfig';
  disabledMessage?: Maybe<Scalars['String']>;
  homeMeters?: Maybe<Scalars['Boolean']>;
  thermostats?: Maybe<Scalars['Boolean']>;
  vehicleChargers?: Maybe<Scalars['Boolean']>;
  vehicles?: Maybe<Scalars['Boolean']>;
};

export type EligibleDeviceEnrollmentConfig = {
  __typename?: 'EligibleDeviceEnrollmentConfig';
  description?: Maybe<ViewConfigText>;
  enrollButton?: Maybe<ViewConfigButton>;
  title?: Maybe<ViewConfigText>;
};

export type EnrollConfirmationModal = {
  __typename?: 'EnrollConfirmationModal';
  description?: Maybe<Scalars['String']>;
  primaryButton?: Maybe<ViewConfigButton>;
  title?: Maybe<Scalars['String']>;
  tosDocument?: Maybe<Scalars['JSON']>;
};

export type EventOptOutMessageConfig = {
  __typename?: 'EventOptOutMessageConfig';
  thermostat?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Scalars['String']>;
  vehicleCharger?: Maybe<Scalars['String']>;
};

export type ExternalContactConfig = {
  __typename?: 'ExternalContactConfig';
  description?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<ExternalContactSectionResolved>>>;
  title?: Maybe<Scalars['String']>;
};

export type ExternalContactSection = {
  __typename?: 'ExternalContactSection';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewConfig?: Maybe<ViewConfig>;
};

export type ExternalContactSectionCreateInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewConfig?: InputMaybe<ViewConfigRelateToOneForCreateInput>;
};

export type ExternalContactSectionManyRelationFilter = {
  every?: InputMaybe<ExternalContactSectionWhereInput>;
  none?: InputMaybe<ExternalContactSectionWhereInput>;
  some?: InputMaybe<ExternalContactSectionWhereInput>;
};

export type ExternalContactSectionOrderByInput = {
  email?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  phone?: InputMaybe<OrderDirection>;
  site?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type ExternalContactSectionRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ExternalContactSectionWhereUniqueInput>>;
  create?: InputMaybe<Array<ExternalContactSectionCreateInput>>;
};

export type ExternalContactSectionRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ExternalContactSectionWhereUniqueInput>>;
  create?: InputMaybe<Array<ExternalContactSectionCreateInput>>;
  disconnect?: InputMaybe<Array<ExternalContactSectionWhereUniqueInput>>;
  set?: InputMaybe<Array<ExternalContactSectionWhereUniqueInput>>;
};

export type ExternalContactSectionResolved = {
  __typename?: 'ExternalContactSectionResolved';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ExternalContactSectionUpdateArgs = {
  data: ExternalContactSectionUpdateInput;
  where: ExternalContactSectionWhereUniqueInput;
};

export type ExternalContactSectionUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewConfig?: InputMaybe<ViewConfigRelateToOneForUpdateInput>;
};

export type ExternalContactSectionWhereInput = {
  AND?: InputMaybe<Array<ExternalContactSectionWhereInput>>;
  NOT?: InputMaybe<Array<ExternalContactSectionWhereInput>>;
  OR?: InputMaybe<Array<ExternalContactSectionWhereInput>>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  phone?: InputMaybe<StringFilter>;
  site?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  viewConfig?: InputMaybe<ViewConfigWhereInput>;
};

export type ExternalContactSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ExternalPartnerIntegrationConfig = {
  __typename?: 'ExternalPartnerIntegrationConfig';
  deviceEnrollmentDescription: Scalars['String'];
  programName: Scalars['String'];
};

export type Faq = {
  __typename?: 'FAQ';
  id: Scalars['ID'];
  items?: Maybe<Array<FaqItem>>;
  itemsCount?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Faq_Subtitle_Document>;
  title?: Maybe<Scalars['String']>;
};


export type FaqItemsArgs = {
  cursor?: InputMaybe<FaqItemWhereUniqueInput>;
  orderBy?: Array<FaqItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FaqItemWhereInput;
};


export type FaqItemsCountArgs = {
  where?: FaqItemWhereInput;
};

export type FaqCreateInput = {
  items?: InputMaybe<FaqItemRelateToManyForCreateInput>;
  slug?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FaqItem = {
  __typename?: 'FAQItem';
  answer?: Maybe<FaqItem_Answer_Document>;
  faq?: Maybe<Faq>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
};

export type FaqItemCreateInput = {
  answer?: InputMaybe<Scalars['JSON']>;
  faq?: InputMaybe<FaqRelateToOneForCreateInput>;
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
};

export type FaqItemManyRelationFilter = {
  every?: InputMaybe<FaqItemWhereInput>;
  none?: InputMaybe<FaqItemWhereInput>;
  some?: InputMaybe<FaqItemWhereInput>;
};

export type FaqItemOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  question?: InputMaybe<OrderDirection>;
};

export type FaqItemRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<FaqItemWhereUniqueInput>>;
  create?: InputMaybe<Array<FaqItemCreateInput>>;
};

export type FaqItemRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<FaqItemWhereUniqueInput>>;
  create?: InputMaybe<Array<FaqItemCreateInput>>;
  disconnect?: InputMaybe<Array<FaqItemWhereUniqueInput>>;
  set?: InputMaybe<Array<FaqItemWhereUniqueInput>>;
};

export type FaqItemUpdateArgs = {
  data: FaqItemUpdateInput;
  where: FaqItemWhereUniqueInput;
};

export type FaqItemUpdateInput = {
  answer?: InputMaybe<Scalars['JSON']>;
  faq?: InputMaybe<FaqRelateToOneForUpdateInput>;
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
};

export type FaqItemWhereInput = {
  AND?: InputMaybe<Array<FaqItemWhereInput>>;
  NOT?: InputMaybe<Array<FaqItemWhereInput>>;
  OR?: InputMaybe<Array<FaqItemWhereInput>>;
  faq?: InputMaybe<FaqWhereInput>;
  id?: InputMaybe<IdFilter>;
  order?: InputMaybe<IntFilter>;
  question?: InputMaybe<StringFilter>;
};

export type FaqItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type FaqItem_Answer_Document = {
  __typename?: 'FAQItem_answer_Document';
  document: Scalars['JSON'];
};


export type FaqItem_Answer_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type FaqOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  slug?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type FaqRelateToOneForCreateInput = {
  connect?: InputMaybe<FaqWhereUniqueInput>;
  create?: InputMaybe<FaqCreateInput>;
};

export type FaqRelateToOneForUpdateInput = {
  connect?: InputMaybe<FaqWhereUniqueInput>;
  create?: InputMaybe<FaqCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type FaqUpdateArgs = {
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
};

export type FaqUpdateInput = {
  items?: InputMaybe<FaqItemRelateToManyForUpdateInput>;
  slug?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FaqWhereInput = {
  AND?: InputMaybe<Array<FaqWhereInput>>;
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  OR?: InputMaybe<Array<FaqWhereInput>>;
  id?: InputMaybe<IdFilter>;
  items?: InputMaybe<FaqItemManyRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type FaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Faq_Subtitle_Document = {
  __typename?: 'FAQ_subtitle_Document';
  document: Scalars['JSON'];
};


export type Faq_Subtitle_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type FaqConfig = {
  __typename?: 'FaqConfig';
  slug: Scalars['String'];
};

export type FieldMetadata = {
  __typename?: 'FieldMetadata';
  appLocation?: Maybe<Scalars['String']>;
  description?: Maybe<FieldMetadata_Description_Document>;
  displayName?: Maybe<Scalars['String']>;
  fieldKey?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  group?: Maybe<FieldMetadataGroup>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  screenshot?: Maybe<ImageFieldOutput>;
};

export type FieldMetadataCreateInput = {
  appLocation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  displayName?: InputMaybe<Scalars['String']>;
  fieldKey?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<FieldMetadataGroupRelateToOneForCreateInput>;
  order?: InputMaybe<Scalars['Int']>;
  screenshot?: InputMaybe<ImageFieldInput>;
};

export type FieldMetadataGroup = {
  __typename?: 'FieldMetadataGroup';
  children?: Maybe<Array<FieldMetadataGroup>>;
  childrenCount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<FieldMetadata>>;
  fieldsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent?: Maybe<FieldMetadataGroup>;
  screenshot?: Maybe<ImageFieldOutput>;
  slug?: Maybe<Scalars['String']>;
};


export type FieldMetadataGroupChildrenArgs = {
  cursor?: InputMaybe<FieldMetadataGroupWhereUniqueInput>;
  orderBy?: Array<FieldMetadataGroupOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FieldMetadataGroupWhereInput;
};


export type FieldMetadataGroupChildrenCountArgs = {
  where?: FieldMetadataGroupWhereInput;
};


export type FieldMetadataGroupFieldsArgs = {
  cursor?: InputMaybe<FieldMetadataWhereUniqueInput>;
  orderBy?: Array<FieldMetadataOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FieldMetadataWhereInput;
};


export type FieldMetadataGroupFieldsCountArgs = {
  where?: FieldMetadataWhereInput;
};

export type FieldMetadataGroupCreateInput = {
  children?: InputMaybe<FieldMetadataGroupRelateToManyForCreateInput>;
  description?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<FieldMetadataRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent?: InputMaybe<FieldMetadataGroupRelateToOneForCreateInput>;
  screenshot?: InputMaybe<ImageFieldInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type FieldMetadataGroupManyRelationFilter = {
  every?: InputMaybe<FieldMetadataGroupWhereInput>;
  none?: InputMaybe<FieldMetadataGroupWhereInput>;
  some?: InputMaybe<FieldMetadataGroupWhereInput>;
};

export type FieldMetadataGroupOrderByInput = {
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  slug?: InputMaybe<OrderDirection>;
};

export type FieldMetadataGroupRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<FieldMetadataGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<FieldMetadataGroupCreateInput>>;
};

export type FieldMetadataGroupRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<FieldMetadataGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<FieldMetadataGroupCreateInput>>;
  disconnect?: InputMaybe<Array<FieldMetadataGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<FieldMetadataGroupWhereUniqueInput>>;
};

export type FieldMetadataGroupRelateToOneForCreateInput = {
  connect?: InputMaybe<FieldMetadataGroupWhereUniqueInput>;
  create?: InputMaybe<FieldMetadataGroupCreateInput>;
};

export type FieldMetadataGroupRelateToOneForUpdateInput = {
  connect?: InputMaybe<FieldMetadataGroupWhereUniqueInput>;
  create?: InputMaybe<FieldMetadataGroupCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type FieldMetadataGroupUpdateArgs = {
  data: FieldMetadataGroupUpdateInput;
  where: FieldMetadataGroupWhereUniqueInput;
};

export type FieldMetadataGroupUpdateInput = {
  children?: InputMaybe<FieldMetadataGroupRelateToManyForUpdateInput>;
  description?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<FieldMetadataRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent?: InputMaybe<FieldMetadataGroupRelateToOneForUpdateInput>;
  screenshot?: InputMaybe<ImageFieldInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type FieldMetadataGroupWhereInput = {
  AND?: InputMaybe<Array<FieldMetadataGroupWhereInput>>;
  NOT?: InputMaybe<Array<FieldMetadataGroupWhereInput>>;
  OR?: InputMaybe<Array<FieldMetadataGroupWhereInput>>;
  children?: InputMaybe<FieldMetadataGroupManyRelationFilter>;
  description?: InputMaybe<StringFilter>;
  fields?: InputMaybe<FieldMetadataManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  parent?: InputMaybe<FieldMetadataGroupWhereInput>;
  slug?: InputMaybe<StringFilter>;
};

export type FieldMetadataGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type FieldMetadataManyRelationFilter = {
  every?: InputMaybe<FieldMetadataWhereInput>;
  none?: InputMaybe<FieldMetadataWhereInput>;
  some?: InputMaybe<FieldMetadataWhereInput>;
};

export type FieldMetadataOrderByInput = {
  appLocation?: InputMaybe<OrderDirection>;
  displayName?: InputMaybe<OrderDirection>;
  fieldKey?: InputMaybe<OrderDirection>;
  fieldType?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
};

export type FieldMetadataRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<FieldMetadataWhereUniqueInput>>;
  create?: InputMaybe<Array<FieldMetadataCreateInput>>;
};

export type FieldMetadataRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<FieldMetadataWhereUniqueInput>>;
  create?: InputMaybe<Array<FieldMetadataCreateInput>>;
  disconnect?: InputMaybe<Array<FieldMetadataWhereUniqueInput>>;
  set?: InputMaybe<Array<FieldMetadataWhereUniqueInput>>;
};

export type FieldMetadataUpdateArgs = {
  data: FieldMetadataUpdateInput;
  where: FieldMetadataWhereUniqueInput;
};

export type FieldMetadataUpdateInput = {
  appLocation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  displayName?: InputMaybe<Scalars['String']>;
  fieldKey?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<FieldMetadataGroupRelateToOneForUpdateInput>;
  order?: InputMaybe<Scalars['Int']>;
  screenshot?: InputMaybe<ImageFieldInput>;
};

export type FieldMetadataWhereInput = {
  AND?: InputMaybe<Array<FieldMetadataWhereInput>>;
  NOT?: InputMaybe<Array<FieldMetadataWhereInput>>;
  OR?: InputMaybe<Array<FieldMetadataWhereInput>>;
  appLocation?: InputMaybe<StringFilter>;
  displayName?: InputMaybe<StringFilter>;
  fieldKey?: InputMaybe<StringFilter>;
  fieldType?: InputMaybe<StringFilter>;
  group?: InputMaybe<FieldMetadataGroupWhereInput>;
  id?: InputMaybe<IdFilter>;
  order?: InputMaybe<IntFilter>;
};

export type FieldMetadataWhereUniqueInput = {
  fieldKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type FieldMetadata_Description_Document = {
  __typename?: 'FieldMetadata_description_Document';
  document: Scalars['JSON'];
};


export type FieldMetadata_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  utilityProgram?: Maybe<UtilityProgram>;
  viewConfig?: Maybe<ViewConfig>;
};

export type GroupCreateInput = {
  name?: InputMaybe<Scalars['String']>;
  utilityProgram?: InputMaybe<UtilityProgramRelateToOneForCreateInput>;
  viewConfig?: InputMaybe<ViewConfigRelateToOneForCreateInput>;
};

export type GroupManyRelationFilter = {
  every?: InputMaybe<GroupWhereInput>;
  none?: InputMaybe<GroupWhereInput>;
  some?: InputMaybe<GroupWhereInput>;
};

export type GroupOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type GroupRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<GroupWhereUniqueInput>>;
  create?: InputMaybe<Array<GroupCreateInput>>;
};

export type GroupRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<GroupWhereUniqueInput>>;
  create?: InputMaybe<Array<GroupCreateInput>>;
  disconnect?: InputMaybe<Array<GroupWhereUniqueInput>>;
  set?: InputMaybe<Array<GroupWhereUniqueInput>>;
};

export type GroupRelateToOneForCreateInput = {
  connect?: InputMaybe<GroupWhereUniqueInput>;
  create?: InputMaybe<GroupCreateInput>;
};

export type GroupRelateToOneForUpdateInput = {
  connect?: InputMaybe<GroupWhereUniqueInput>;
  create?: InputMaybe<GroupCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type GroupUpdateArgs = {
  data: GroupUpdateInput;
  where: GroupWhereUniqueInput;
};

export type GroupUpdateInput = {
  name?: InputMaybe<Scalars['String']>;
  utilityProgram?: InputMaybe<UtilityProgramRelateToOneForUpdateInput>;
  viewConfig?: InputMaybe<ViewConfigRelateToOneForUpdateInput>;
};

export type GroupWhereInput = {
  AND?: InputMaybe<Array<GroupWhereInput>>;
  NOT?: InputMaybe<Array<GroupWhereInput>>;
  OR?: InputMaybe<Array<GroupWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  utilityProgram?: InputMaybe<UtilityProgramWhereInput>;
  viewConfig?: InputMaybe<ViewConfigWhereInput>;
};

export type GroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  viewConfig?: InputMaybe<ViewConfigWhereUniqueInput>;
};

export type HomeEnergyPreviewConfig = {
  __typename?: 'HomeEnergyPreviewConfig';
  touCsl?: Maybe<Scalars['String']>;
};

export type HvacAttestationConfig = {
  __typename?: 'HvacAttestationConfig';
  requireHvacAttestation?: Maybe<Scalars['Boolean']>;
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ImageExtension {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png',
  Webp = 'webp'
}

export type ImageFieldInput = {
  upload: Scalars['Upload'];
};

export type ImageFieldOutput = {
  __typename?: 'ImageFieldOutput';
  extension: ImageExtension;
  filesize: Scalars['Int'];
  height: Scalars['Int'];
  id: Scalars['ID'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fieldMeta?: Maybe<Scalars['JSON']>;
  isFilterable: Scalars['Boolean'];
  isNonNull?: Maybe<Array<KeystoneAdminUiFieldMetaIsNonNull>>;
  isOrderable: Scalars['Boolean'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export enum KeystoneAdminUiFieldMetaIsNonNull {
  Create = 'create',
  Read = 'read',
  Update = 'update'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiGraphQl = {
  __typename?: 'KeystoneAdminUIGraphQL';
  names: KeystoneAdminUiGraphQlNames;
};

export type KeystoneAdminUiGraphQlNames = {
  __typename?: 'KeystoneAdminUIGraphQLNames';
  createInputName: Scalars['String'];
  createManyMutationName: Scalars['String'];
  createMutationName: Scalars['String'];
  deleteManyMutationName: Scalars['String'];
  deleteMutationName: Scalars['String'];
  itemQueryName: Scalars['String'];
  listOrderName: Scalars['String'];
  listQueryCountName: Scalars['String'];
  listQueryName: Scalars['String'];
  outputTypeName: Scalars['String'];
  relateToManyForCreateInputName: Scalars['String'];
  relateToManyForUpdateInputName: Scalars['String'];
  relateToOneForCreateInputName: Scalars['String'];
  relateToOneForUpdateInputName: Scalars['String'];
  updateInputName: Scalars['String'];
  updateManyInputName: Scalars['String'];
  updateManyMutationName: Scalars['String'];
  updateMutationName: Scalars['String'];
  whereInputName: Scalars['String'];
  whereUniqueInputName: Scalars['String'];
};

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  graphql: KeystoneAdminUiGraphQl;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean'];
  hideDelete: Scalars['Boolean'];
  initialColumns: Array<Scalars['String']>;
  initialSearchFields: Array<Scalars['String']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean'];
  isSingleton: Scalars['Boolean'];
  itemQueryName: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  labelField: Scalars['String'];
  listQueryName: Scalars['String'];
  pageSize: Scalars['Int'];
  path: Scalars['String'];
  plural: Scalars['String'];
  singular: Scalars['String'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export type LearnMoreViewConfig = {
  __typename?: 'LearnMoreViewConfig';
  buttonTitle: Scalars['String'];
  navigateTo?: Maybe<Scalars['String']>;
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type LevelThreeConfig = {
  __typename?: 'LevelThreeConfig';
  levelThreeSubtitle?: Maybe<Scalars['String']>;
  levelThreeSummary?: Maybe<Scalars['JSON']>;
  valueChips?: Maybe<Array<Maybe<ValueChipData>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticateUserWithPassword?: Maybe<UserAuthenticationWithPasswordResult>;
  createExternalContactSection?: Maybe<ExternalContactSection>;
  createExternalContactSections?: Maybe<Array<Maybe<ExternalContactSection>>>;
  createFAQ?: Maybe<Faq>;
  createFAQItem?: Maybe<FaqItem>;
  createFAQItems?: Maybe<Array<Maybe<FaqItem>>>;
  createFAQS?: Maybe<Array<Maybe<Faq>>>;
  createFieldMetadata?: Maybe<FieldMetadata>;
  createFieldMetadataGroup?: Maybe<FieldMetadataGroup>;
  createFieldMetadataGroups?: Maybe<Array<Maybe<FieldMetadataGroup>>>;
  createFieldMetadataItems?: Maybe<Array<Maybe<FieldMetadata>>>;
  createGroup?: Maybe<Group>;
  createGroups?: Maybe<Array<Maybe<Group>>>;
  createInitialUser: UserAuthenticationWithPasswordSuccess;
  createOnboardingInformationItem?: Maybe<OnboardingInformationItem>;
  createOnboardingInformationItems?: Maybe<Array<Maybe<OnboardingInformationItem>>>;
  createUser?: Maybe<User>;
  createUsers?: Maybe<Array<Maybe<User>>>;
  createUtilityProgram?: Maybe<UtilityProgram>;
  createUtilityProgramMetadataKey?: Maybe<UtilityProgramMetadataKey>;
  createUtilityProgramMetadataKeys?: Maybe<Array<Maybe<UtilityProgramMetadataKey>>>;
  createUtilityPrograms?: Maybe<Array<Maybe<UtilityProgram>>>;
  createValueChip?: Maybe<ValueChip>;
  createValueChips?: Maybe<Array<Maybe<ValueChip>>>;
  createViewConfig?: Maybe<ViewConfig>;
  createViewConfigs?: Maybe<Array<Maybe<ViewConfig>>>;
  deleteExternalContactSection?: Maybe<ExternalContactSection>;
  deleteExternalContactSections?: Maybe<Array<Maybe<ExternalContactSection>>>;
  deleteFAQ?: Maybe<Faq>;
  deleteFAQItem?: Maybe<FaqItem>;
  deleteFAQItems?: Maybe<Array<Maybe<FaqItem>>>;
  deleteFAQS?: Maybe<Array<Maybe<Faq>>>;
  deleteFieldMetadata?: Maybe<FieldMetadata>;
  deleteFieldMetadataGroup?: Maybe<FieldMetadataGroup>;
  deleteFieldMetadataGroups?: Maybe<Array<Maybe<FieldMetadataGroup>>>;
  deleteFieldMetadataItems?: Maybe<Array<Maybe<FieldMetadata>>>;
  deleteGroup?: Maybe<Group>;
  deleteGroups?: Maybe<Array<Maybe<Group>>>;
  deleteOnboardingInformationItem?: Maybe<OnboardingInformationItem>;
  deleteOnboardingInformationItems?: Maybe<Array<Maybe<OnboardingInformationItem>>>;
  deleteUser?: Maybe<User>;
  deleteUsers?: Maybe<Array<Maybe<User>>>;
  deleteUtilityProgram?: Maybe<UtilityProgram>;
  deleteUtilityProgramMetadataKey?: Maybe<UtilityProgramMetadataKey>;
  deleteUtilityProgramMetadataKeys?: Maybe<Array<Maybe<UtilityProgramMetadataKey>>>;
  deleteUtilityPrograms?: Maybe<Array<Maybe<UtilityProgram>>>;
  deleteValueChip?: Maybe<ValueChip>;
  deleteValueChips?: Maybe<Array<Maybe<ValueChip>>>;
  deleteViewConfig?: Maybe<ViewConfig>;
  deleteViewConfigs?: Maybe<Array<Maybe<ViewConfig>>>;
  endSession: Scalars['Boolean'];
  ingestTransformedViewConfig?: Maybe<ViewConfig>;
  updateExternalContactSection?: Maybe<ExternalContactSection>;
  updateExternalContactSections?: Maybe<Array<Maybe<ExternalContactSection>>>;
  updateFAQ?: Maybe<Faq>;
  updateFAQItem?: Maybe<FaqItem>;
  updateFAQItems?: Maybe<Array<Maybe<FaqItem>>>;
  updateFAQS?: Maybe<Array<Maybe<Faq>>>;
  updateFieldMetadata?: Maybe<FieldMetadata>;
  updateFieldMetadataGroup?: Maybe<FieldMetadataGroup>;
  updateFieldMetadataGroups?: Maybe<Array<Maybe<FieldMetadataGroup>>>;
  updateFieldMetadataItems?: Maybe<Array<Maybe<FieldMetadata>>>;
  updateGroup?: Maybe<Group>;
  updateGroups?: Maybe<Array<Maybe<Group>>>;
  updateOnboardingInformationItem?: Maybe<OnboardingInformationItem>;
  updateOnboardingInformationItems?: Maybe<Array<Maybe<OnboardingInformationItem>>>;
  updateUser?: Maybe<User>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
  updateUtilityProgram?: Maybe<UtilityProgram>;
  updateUtilityProgramMetadataKey?: Maybe<UtilityProgramMetadataKey>;
  updateUtilityProgramMetadataKeys?: Maybe<Array<Maybe<UtilityProgramMetadataKey>>>;
  updateUtilityPrograms?: Maybe<Array<Maybe<UtilityProgram>>>;
  updateValueChip?: Maybe<ValueChip>;
  updateValueChips?: Maybe<Array<Maybe<ValueChip>>>;
  updateViewConfig?: Maybe<ViewConfig>;
  updateViewConfigs?: Maybe<Array<Maybe<ViewConfig>>>;
};


export type MutationAuthenticateUserWithPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateExternalContactSectionArgs = {
  data: ExternalContactSectionCreateInput;
};


export type MutationCreateExternalContactSectionsArgs = {
  data: Array<ExternalContactSectionCreateInput>;
};


export type MutationCreateFaqArgs = {
  data: FaqCreateInput;
};


export type MutationCreateFaqItemArgs = {
  data: FaqItemCreateInput;
};


export type MutationCreateFaqItemsArgs = {
  data: Array<FaqItemCreateInput>;
};


export type MutationCreateFaqsArgs = {
  data: Array<FaqCreateInput>;
};


export type MutationCreateFieldMetadataArgs = {
  data: FieldMetadataCreateInput;
};


export type MutationCreateFieldMetadataGroupArgs = {
  data: FieldMetadataGroupCreateInput;
};


export type MutationCreateFieldMetadataGroupsArgs = {
  data: Array<FieldMetadataGroupCreateInput>;
};


export type MutationCreateFieldMetadataItemsArgs = {
  data: Array<FieldMetadataCreateInput>;
};


export type MutationCreateGroupArgs = {
  data: GroupCreateInput;
};


export type MutationCreateGroupsArgs = {
  data: Array<GroupCreateInput>;
};


export type MutationCreateInitialUserArgs = {
  data: CreateInitialUserInput;
};


export type MutationCreateOnboardingInformationItemArgs = {
  data: OnboardingInformationItemCreateInput;
};


export type MutationCreateOnboardingInformationItemsArgs = {
  data: Array<OnboardingInformationItemCreateInput>;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateUsersArgs = {
  data: Array<UserCreateInput>;
};


export type MutationCreateUtilityProgramArgs = {
  data: UtilityProgramCreateInput;
};


export type MutationCreateUtilityProgramMetadataKeyArgs = {
  data: UtilityProgramMetadataKeyCreateInput;
};


export type MutationCreateUtilityProgramMetadataKeysArgs = {
  data: Array<UtilityProgramMetadataKeyCreateInput>;
};


export type MutationCreateUtilityProgramsArgs = {
  data: Array<UtilityProgramCreateInput>;
};


export type MutationCreateValueChipArgs = {
  data: ValueChipCreateInput;
};


export type MutationCreateValueChipsArgs = {
  data: Array<ValueChipCreateInput>;
};


export type MutationCreateViewConfigArgs = {
  data: ViewConfigCreateInput;
};


export type MutationCreateViewConfigsArgs = {
  data: Array<ViewConfigCreateInput>;
};


export type MutationDeleteExternalContactSectionArgs = {
  where: ExternalContactSectionWhereUniqueInput;
};


export type MutationDeleteExternalContactSectionsArgs = {
  where: Array<ExternalContactSectionWhereUniqueInput>;
};


export type MutationDeleteFaqArgs = {
  where: FaqWhereUniqueInput;
};


export type MutationDeleteFaqItemArgs = {
  where: FaqItemWhereUniqueInput;
};


export type MutationDeleteFaqItemsArgs = {
  where: Array<FaqItemWhereUniqueInput>;
};


export type MutationDeleteFaqsArgs = {
  where: Array<FaqWhereUniqueInput>;
};


export type MutationDeleteFieldMetadataArgs = {
  where: FieldMetadataWhereUniqueInput;
};


export type MutationDeleteFieldMetadataGroupArgs = {
  where: FieldMetadataGroupWhereUniqueInput;
};


export type MutationDeleteFieldMetadataGroupsArgs = {
  where: Array<FieldMetadataGroupWhereUniqueInput>;
};


export type MutationDeleteFieldMetadataItemsArgs = {
  where: Array<FieldMetadataWhereUniqueInput>;
};


export type MutationDeleteGroupArgs = {
  where: GroupWhereUniqueInput;
};


export type MutationDeleteGroupsArgs = {
  where: Array<GroupWhereUniqueInput>;
};


export type MutationDeleteOnboardingInformationItemArgs = {
  where: OnboardingInformationItemWhereUniqueInput;
};


export type MutationDeleteOnboardingInformationItemsArgs = {
  where: Array<OnboardingInformationItemWhereUniqueInput>;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteUsersArgs = {
  where: Array<UserWhereUniqueInput>;
};


export type MutationDeleteUtilityProgramArgs = {
  where: UtilityProgramWhereUniqueInput;
};


export type MutationDeleteUtilityProgramMetadataKeyArgs = {
  where: UtilityProgramMetadataKeyWhereUniqueInput;
};


export type MutationDeleteUtilityProgramMetadataKeysArgs = {
  where: Array<UtilityProgramMetadataKeyWhereUniqueInput>;
};


export type MutationDeleteUtilityProgramsArgs = {
  where: Array<UtilityProgramWhereUniqueInput>;
};


export type MutationDeleteValueChipArgs = {
  where: ValueChipWhereUniqueInput;
};


export type MutationDeleteValueChipsArgs = {
  where: Array<ValueChipWhereUniqueInput>;
};


export type MutationDeleteViewConfigArgs = {
  where: ViewConfigWhereUniqueInput;
};


export type MutationDeleteViewConfigsArgs = {
  where: Array<ViewConfigWhereUniqueInput>;
};


export type MutationIngestTransformedViewConfigArgs = {
  frontendViewConfig: Scalars['JSON'];
  name: Scalars['String'];
};


export type MutationUpdateExternalContactSectionArgs = {
  data: ExternalContactSectionUpdateInput;
  where: ExternalContactSectionWhereUniqueInput;
};


export type MutationUpdateExternalContactSectionsArgs = {
  data: Array<ExternalContactSectionUpdateArgs>;
};


export type MutationUpdateFaqArgs = {
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
};


export type MutationUpdateFaqItemArgs = {
  data: FaqItemUpdateInput;
  where: FaqItemWhereUniqueInput;
};


export type MutationUpdateFaqItemsArgs = {
  data: Array<FaqItemUpdateArgs>;
};


export type MutationUpdateFaqsArgs = {
  data: Array<FaqUpdateArgs>;
};


export type MutationUpdateFieldMetadataArgs = {
  data: FieldMetadataUpdateInput;
  where: FieldMetadataWhereUniqueInput;
};


export type MutationUpdateFieldMetadataGroupArgs = {
  data: FieldMetadataGroupUpdateInput;
  where: FieldMetadataGroupWhereUniqueInput;
};


export type MutationUpdateFieldMetadataGroupsArgs = {
  data: Array<FieldMetadataGroupUpdateArgs>;
};


export type MutationUpdateFieldMetadataItemsArgs = {
  data: Array<FieldMetadataUpdateArgs>;
};


export type MutationUpdateGroupArgs = {
  data: GroupUpdateInput;
  where: GroupWhereUniqueInput;
};


export type MutationUpdateGroupsArgs = {
  data: Array<GroupUpdateArgs>;
};


export type MutationUpdateOnboardingInformationItemArgs = {
  data: OnboardingInformationItemUpdateInput;
  where: OnboardingInformationItemWhereUniqueInput;
};


export type MutationUpdateOnboardingInformationItemsArgs = {
  data: Array<OnboardingInformationItemUpdateArgs>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUsersArgs = {
  data: Array<UserUpdateArgs>;
};


export type MutationUpdateUtilityProgramArgs = {
  data: UtilityProgramUpdateInput;
  where: UtilityProgramWhereUniqueInput;
};


export type MutationUpdateUtilityProgramMetadataKeyArgs = {
  data: UtilityProgramMetadataKeyUpdateInput;
  where: UtilityProgramMetadataKeyWhereUniqueInput;
};


export type MutationUpdateUtilityProgramMetadataKeysArgs = {
  data: Array<UtilityProgramMetadataKeyUpdateArgs>;
};


export type MutationUpdateUtilityProgramsArgs = {
  data: Array<UtilityProgramUpdateArgs>;
};


export type MutationUpdateValueChipArgs = {
  data: ValueChipUpdateInput;
  where: ValueChipWhereUniqueInput;
};


export type MutationUpdateValueChipsArgs = {
  data: Array<ValueChipUpdateArgs>;
};


export type MutationUpdateViewConfigArgs = {
  data: ViewConfigUpdateInput;
  where: ViewConfigWhereUniqueInput;
};


export type MutationUpdateViewConfigsArgs = {
  data: Array<ViewConfigUpdateArgs>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type OnboardingInformationItem = {
  __typename?: 'OnboardingInformationItem';
  featherIcon?: Maybe<Scalars['String']>;
  iconBackgroundColor?: Maybe<Scalars['String']>;
  iconColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tagBackgroundColor?: Maybe<Scalars['String']>;
  tagColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  utilityProgram?: Maybe<Array<ViewConfig>>;
  utilityProgramCount?: Maybe<Scalars['Int']>;
};


export type OnboardingInformationItemUtilityProgramArgs = {
  cursor?: InputMaybe<ViewConfigWhereUniqueInput>;
  orderBy?: Array<ViewConfigOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ViewConfigWhereInput;
};


export type OnboardingInformationItemUtilityProgramCountArgs = {
  where?: ViewConfigWhereInput;
};

export type OnboardingInformationItemCreateInput = {
  featherIcon?: InputMaybe<Scalars['String']>;
  iconBackgroundColor?: InputMaybe<Scalars['String']>;
  iconColor?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  tagBackgroundColor?: InputMaybe<Scalars['String']>;
  tagColor?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  utilityProgram?: InputMaybe<ViewConfigRelateToManyForCreateInput>;
};

export type OnboardingInformationItemManyRelationFilter = {
  every?: InputMaybe<OnboardingInformationItemWhereInput>;
  none?: InputMaybe<OnboardingInformationItemWhereInput>;
  some?: InputMaybe<OnboardingInformationItemWhereInput>;
};

export type OnboardingInformationItemOrderByInput = {
  featherIcon?: InputMaybe<OrderDirection>;
  iconBackgroundColor?: InputMaybe<OrderDirection>;
  iconColor?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  order?: InputMaybe<OrderDirection>;
  subtitle?: InputMaybe<OrderDirection>;
  tag?: InputMaybe<OrderDirection>;
  tagBackgroundColor?: InputMaybe<OrderDirection>;
  tagColor?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type OnboardingInformationItemRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<OnboardingInformationItemWhereUniqueInput>>;
  create?: InputMaybe<Array<OnboardingInformationItemCreateInput>>;
};

export type OnboardingInformationItemRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<OnboardingInformationItemWhereUniqueInput>>;
  create?: InputMaybe<Array<OnboardingInformationItemCreateInput>>;
  disconnect?: InputMaybe<Array<OnboardingInformationItemWhereUniqueInput>>;
  set?: InputMaybe<Array<OnboardingInformationItemWhereUniqueInput>>;
};

export type OnboardingInformationItemUpdateArgs = {
  data: OnboardingInformationItemUpdateInput;
  where: OnboardingInformationItemWhereUniqueInput;
};

export type OnboardingInformationItemUpdateInput = {
  featherIcon?: InputMaybe<Scalars['String']>;
  iconBackgroundColor?: InputMaybe<Scalars['String']>;
  iconColor?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  tagBackgroundColor?: InputMaybe<Scalars['String']>;
  tagColor?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  utilityProgram?: InputMaybe<ViewConfigRelateToManyForUpdateInput>;
};

export type OnboardingInformationItemWhereInput = {
  AND?: InputMaybe<Array<OnboardingInformationItemWhereInput>>;
  NOT?: InputMaybe<Array<OnboardingInformationItemWhereInput>>;
  OR?: InputMaybe<Array<OnboardingInformationItemWhereInput>>;
  featherIcon?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IdFilter>;
  order?: InputMaybe<IntFilter>;
  subtitle?: InputMaybe<StringFilter>;
  tag?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  utilityProgram?: InputMaybe<ViewConfigManyRelationFilter>;
};

export type OnboardingInformationItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type OnboardingViewConfig = {
  __typename?: 'OnboardingViewConfig';
  enrollConfirmation?: Maybe<ViewConfigModal>;
  excludeHeaderAnimation?: Maybe<Scalars['Boolean']>;
  footer?: Maybe<Scalars['String']>;
  informationList: Scalars['JSON'];
  primaryButton?: Maybe<ViewConfigButton>;
  programName: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type PasswordState = {
  __typename?: 'PasswordState';
  isSet: Scalars['Boolean'];
};

export type ProgramCardConfig = {
  __typename?: 'ProgramCardConfig';
  enrollmentEndDate?: Maybe<Scalars['DateTime']>;
  offPeakChargingLabel?: Maybe<Scalars['String']>;
  rollingDeadline?: Maybe<Scalars['Boolean']>;
  savingsTagline?: Maybe<Scalars['String']>;
  shareLinkUrl?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  authenticatedItem?: Maybe<AuthenticatedItem>;
  externalContactSection?: Maybe<ExternalContactSection>;
  externalContactSections?: Maybe<Array<ExternalContactSection>>;
  externalContactSectionsCount?: Maybe<Scalars['Int']>;
  fAQ?: Maybe<Faq>;
  fAQItem?: Maybe<FaqItem>;
  fAQItems?: Maybe<Array<FaqItem>>;
  fAQItemsCount?: Maybe<Scalars['Int']>;
  fAQS?: Maybe<Array<Faq>>;
  fAQSCount?: Maybe<Scalars['Int']>;
  fieldMetadata?: Maybe<FieldMetadata>;
  fieldMetadataGroup?: Maybe<FieldMetadataGroup>;
  fieldMetadataGroups?: Maybe<Array<FieldMetadataGroup>>;
  fieldMetadataGroupsCount?: Maybe<Scalars['Int']>;
  fieldMetadataItems?: Maybe<Array<FieldMetadata>>;
  fieldMetadataItemsCount?: Maybe<Scalars['Int']>;
  group?: Maybe<Group>;
  groups?: Maybe<Array<Group>>;
  groupsCount?: Maybe<Scalars['Int']>;
  keystone: KeystoneMeta;
  onboardingInformationItem?: Maybe<OnboardingInformationItem>;
  onboardingInformationItems?: Maybe<Array<OnboardingInformationItem>>;
  onboardingInformationItemsCount?: Maybe<Scalars['Int']>;
  resolvedGroupViewConfig?: Maybe<TransformedViewConfig>;
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']>;
  utilityProgram?: Maybe<UtilityProgram>;
  utilityProgramMetadataKey?: Maybe<UtilityProgramMetadataKey>;
  utilityProgramMetadataKeys?: Maybe<Array<UtilityProgramMetadataKey>>;
  utilityProgramMetadataKeysCount?: Maybe<Scalars['Int']>;
  utilityPrograms?: Maybe<Array<UtilityProgram>>;
  utilityProgramsCount?: Maybe<Scalars['Int']>;
  valueChip?: Maybe<ValueChip>;
  valueChips?: Maybe<Array<ValueChip>>;
  valueChipsCount?: Maybe<Scalars['Int']>;
  viewConfig?: Maybe<ViewConfig>;
  viewConfigs?: Maybe<Array<ViewConfig>>;
  viewConfigsCount?: Maybe<Scalars['Int']>;
};


export type QueryExternalContactSectionArgs = {
  where: ExternalContactSectionWhereUniqueInput;
};


export type QueryExternalContactSectionsArgs = {
  cursor?: InputMaybe<ExternalContactSectionWhereUniqueInput>;
  orderBy?: Array<ExternalContactSectionOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ExternalContactSectionWhereInput;
};


export type QueryExternalContactSectionsCountArgs = {
  where?: ExternalContactSectionWhereInput;
};


export type QueryFAqArgs = {
  where: FaqWhereUniqueInput;
};


export type QueryFAqItemArgs = {
  where: FaqItemWhereUniqueInput;
};


export type QueryFAqItemsArgs = {
  cursor?: InputMaybe<FaqItemWhereUniqueInput>;
  orderBy?: Array<FaqItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FaqItemWhereInput;
};


export type QueryFAqItemsCountArgs = {
  where?: FaqItemWhereInput;
};


export type QueryFAqsArgs = {
  cursor?: InputMaybe<FaqWhereUniqueInput>;
  orderBy?: Array<FaqOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FaqWhereInput;
};


export type QueryFAqsCountArgs = {
  where?: FaqWhereInput;
};


export type QueryFieldMetadataArgs = {
  where: FieldMetadataWhereUniqueInput;
};


export type QueryFieldMetadataGroupArgs = {
  where: FieldMetadataGroupWhereUniqueInput;
};


export type QueryFieldMetadataGroupsArgs = {
  cursor?: InputMaybe<FieldMetadataGroupWhereUniqueInput>;
  orderBy?: Array<FieldMetadataGroupOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FieldMetadataGroupWhereInput;
};


export type QueryFieldMetadataGroupsCountArgs = {
  where?: FieldMetadataGroupWhereInput;
};


export type QueryFieldMetadataItemsArgs = {
  cursor?: InputMaybe<FieldMetadataWhereUniqueInput>;
  orderBy?: Array<FieldMetadataOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FieldMetadataWhereInput;
};


export type QueryFieldMetadataItemsCountArgs = {
  where?: FieldMetadataWhereInput;
};


export type QueryGroupArgs = {
  where: GroupWhereUniqueInput;
};


export type QueryGroupsArgs = {
  cursor?: InputMaybe<GroupWhereUniqueInput>;
  orderBy?: Array<GroupOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GroupWhereInput;
};


export type QueryGroupsCountArgs = {
  where?: GroupWhereInput;
};


export type QueryOnboardingInformationItemArgs = {
  where: OnboardingInformationItemWhereUniqueInput;
};


export type QueryOnboardingInformationItemsArgs = {
  cursor?: InputMaybe<OnboardingInformationItemWhereUniqueInput>;
  orderBy?: Array<OnboardingInformationItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: OnboardingInformationItemWhereInput;
};


export type QueryOnboardingInformationItemsCountArgs = {
  where?: OnboardingInformationItemWhereInput;
};


export type QueryResolvedGroupViewConfigArgs = {
  groupName?: InputMaybe<Scalars['String']>;
  utilityProgramId: Scalars['ID'];
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: UserWhereInput;
};


export type QueryUsersCountArgs = {
  where?: UserWhereInput;
};


export type QueryUtilityProgramArgs = {
  where: UtilityProgramWhereUniqueInput;
};


export type QueryUtilityProgramMetadataKeyArgs = {
  where: UtilityProgramMetadataKeyWhereUniqueInput;
};


export type QueryUtilityProgramMetadataKeysArgs = {
  cursor?: InputMaybe<UtilityProgramMetadataKeyWhereUniqueInput>;
  orderBy?: Array<UtilityProgramMetadataKeyOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: UtilityProgramMetadataKeyWhereInput;
};


export type QueryUtilityProgramMetadataKeysCountArgs = {
  where?: UtilityProgramMetadataKeyWhereInput;
};


export type QueryUtilityProgramsArgs = {
  cursor?: InputMaybe<UtilityProgramWhereUniqueInput>;
  orderBy?: Array<UtilityProgramOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: UtilityProgramWhereInput;
};


export type QueryUtilityProgramsCountArgs = {
  where?: UtilityProgramWhereInput;
};


export type QueryValueChipArgs = {
  where: ValueChipWhereUniqueInput;
};


export type QueryValueChipsArgs = {
  cursor?: InputMaybe<ValueChipWhereUniqueInput>;
  orderBy?: Array<ValueChipOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ValueChipWhereInput;
};


export type QueryValueChipsCountArgs = {
  where?: ValueChipWhereInput;
};


export type QueryViewConfigArgs = {
  where: ViewConfigWhereUniqueInput;
};


export type QueryViewConfigsArgs = {
  cursor?: InputMaybe<ViewConfigWhereUniqueInput>;
  orderBy?: Array<ViewConfigOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ViewConfigWhereInput;
};


export type QueryViewConfigsCountArgs = {
  where?: ViewConfigWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type ReferralConfig = {
  __typename?: 'ReferralConfig';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  programLogoUrl: Scalars['String'];
  referralCodes: Scalars['JSON'];
  showTag?: Maybe<Scalars['Boolean']>;
  subtitle: Scalars['String'];
  tagText?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ResidenceVerificationConfig = {
  __typename?: 'ResidenceVerificationConfig';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ScheduleCharging = {
  __typename?: 'ScheduleCharging';
  subtitle?: Maybe<Scalars['String']>;
};

export type SchedulerViewConfig = {
  __typename?: 'SchedulerViewConfig';
  button?: Maybe<ViewConfigButton>;
  description: Scalars['String'];
  disenrollConfirmation?: Maybe<ViewConfigModal>;
  enrolledAlert?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SignupPageConfig = {
  __typename?: 'SignupPageConfig';
  signupText?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<StringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type SuccessViewConfig = {
  __typename?: 'SuccessViewConfig';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TransformedViewConfig = {
  __typename?: 'TransformedViewConfig';
  accountNumberEntry?: Maybe<AccountNumberEntry>;
  addressSelection?: Maybe<AddressSelectionConfig>;
  bannerLogoUrl?: Maybe<Scalars['String']>;
  chargeForecast?: Maybe<ChargeForecastConfig>;
  colorScheme?: Maybe<ColorSchemeConfig>;
  customAppStoreUrl?: Maybe<Scalars['String']>;
  customPlayStoreUrl?: Maybe<Scalars['String']>;
  dashboard?: Maybe<DashboardConfig>;
  disabledDevices?: Maybe<DisabledDevicesConfig>;
  eligibleDeviceEnrollment?: Maybe<EligibleDeviceEnrollmentConfig>;
  enrolledFunctionality?: Maybe<Scalars['JSON']>;
  enrollmentConfirmationModal?: Maybe<EnrollConfirmationModal>;
  eventOptOutMessage?: Maybe<EventOptOutMessageConfig>;
  externalContact?: Maybe<ExternalContactConfig>;
  externalPartnerIntegration?: Maybe<ExternalPartnerIntegrationConfig>;
  faq?: Maybe<FaqConfig>;
  faqUrl?: Maybe<Scalars['String']>;
  homeEnergyPreview?: Maybe<HomeEnergyPreviewConfig>;
  hvacAttestation?: Maybe<HvacAttestationConfig>;
  learnMore: LearnMoreViewConfig;
  levelThreeConfig?: Maybe<LevelThreeConfig>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarding: OnboardingViewConfig;
  postApplicationDocument?: Maybe<Scalars['JSON']>;
  programCard?: Maybe<ProgramCardConfig>;
  referral: ReferralConfig;
  residenceVerification?: Maybe<ResidenceVerificationConfig>;
  rewardsInviteDescription?: Maybe<Scalars['String']>;
  rewardsInviteTitle?: Maybe<Scalars['String']>;
  scheduleCharging?: Maybe<ScheduleCharging>;
  scheduler: SchedulerViewConfig;
  secondaryLogoUrl?: Maybe<Scalars['String']>;
  signupPage?: Maybe<SignupPageConfig>;
  thermostatSaveMoneyAlert?: Maybe<Scalars['String']>;
  tosDocument?: Maybe<Scalars['JSON']>;
  tosUrl?: Maybe<Scalars['String']>;
  unenrollmentDeflection?: Maybe<Array<Maybe<UnenrollmentDeflectionEntry>>>;
  unenrollmentWarningText?: Maybe<Scalars['String']>;
  useMultiProgramFlow: Scalars['Boolean'];
  utilityProgramConnect?: Maybe<UtilityProgramConnectViewConfig>;
};

export type UnenrollmentDeflectionEntry = {
  __typename?: 'UnenrollmentDeflectionEntry';
  articleText?: Maybe<Scalars['String']>;
  articleUrl: Scalars['String'];
  device: Scalars['String'];
  reasons: Array<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<PasswordState>;
};

export type UserAuthenticationWithPasswordFailure = {
  __typename?: 'UserAuthenticationWithPasswordFailure';
  message: Scalars['String'];
};

export type UserAuthenticationWithPasswordResult = UserAuthenticationWithPasswordFailure | UserAuthenticationWithPasswordSuccess;

export type UserAuthenticationWithPasswordSuccess = {
  __typename?: 'UserAuthenticationWithPasswordSuccess';
  item: User;
  sessionToken: Scalars['String'];
};

export type UserCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UserOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isAdmin?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type UserUpdateArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isAdmin?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type UserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UtilityProgram = {
  __typename?: 'UtilityProgram';
  baseViewConfig?: Maybe<ViewConfig>;
  groups?: Maybe<Array<Group>>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  metadataKey?: Maybe<Array<UtilityProgramMetadataKey>>;
  metadataKeyCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sponsorName?: Maybe<Scalars['String']>;
  useCmsViewConfig?: Maybe<Scalars['Boolean']>;
  utilityProgramId?: Maybe<Scalars['Int']>;
};


export type UtilityProgramGroupsArgs = {
  cursor?: InputMaybe<GroupWhereUniqueInput>;
  orderBy?: Array<GroupOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GroupWhereInput;
};


export type UtilityProgramGroupsCountArgs = {
  where?: GroupWhereInput;
};


export type UtilityProgramMetadataKeyArgs = {
  cursor?: InputMaybe<UtilityProgramMetadataKeyWhereUniqueInput>;
  orderBy?: Array<UtilityProgramMetadataKeyOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: UtilityProgramMetadataKeyWhereInput;
};


export type UtilityProgramMetadataKeyCountArgs = {
  where?: UtilityProgramMetadataKeyWhereInput;
};

export type UtilityProgramConnectViewConfig = {
  __typename?: 'UtilityProgramConnectViewConfig';
  success: SuccessViewConfig;
};

export type UtilityProgramCreateInput = {
  baseViewConfig?: InputMaybe<ViewConfigRelateToOneForCreateInput>;
  groups?: InputMaybe<GroupRelateToManyForCreateInput>;
  metadataKey?: InputMaybe<UtilityProgramMetadataKeyRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']>;
  sponsorName?: InputMaybe<Scalars['String']>;
  useCmsViewConfig?: InputMaybe<Scalars['Boolean']>;
  utilityProgramId?: InputMaybe<Scalars['Int']>;
};

export type UtilityProgramManyRelationFilter = {
  every?: InputMaybe<UtilityProgramWhereInput>;
  none?: InputMaybe<UtilityProgramWhereInput>;
  some?: InputMaybe<UtilityProgramWhereInput>;
};

export type UtilityProgramMetadataKey = {
  __typename?: 'UtilityProgramMetadataKey';
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  utilityProgram?: Maybe<Array<UtilityProgram>>;
  utilityProgramCount?: Maybe<Scalars['Int']>;
};


export type UtilityProgramMetadataKeyUtilityProgramArgs = {
  cursor?: InputMaybe<UtilityProgramWhereUniqueInput>;
  orderBy?: Array<UtilityProgramOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: UtilityProgramWhereInput;
};


export type UtilityProgramMetadataKeyUtilityProgramCountArgs = {
  where?: UtilityProgramWhereInput;
};

export type UtilityProgramMetadataKeyCreateInput = {
  key?: InputMaybe<Scalars['String']>;
  utilityProgram?: InputMaybe<UtilityProgramRelateToManyForCreateInput>;
};

export type UtilityProgramMetadataKeyManyRelationFilter = {
  every?: InputMaybe<UtilityProgramMetadataKeyWhereInput>;
  none?: InputMaybe<UtilityProgramMetadataKeyWhereInput>;
  some?: InputMaybe<UtilityProgramMetadataKeyWhereInput>;
};

export type UtilityProgramMetadataKeyOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  key?: InputMaybe<OrderDirection>;
};

export type UtilityProgramMetadataKeyRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UtilityProgramMetadataKeyWhereUniqueInput>>;
  create?: InputMaybe<Array<UtilityProgramMetadataKeyCreateInput>>;
};

export type UtilityProgramMetadataKeyRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UtilityProgramMetadataKeyWhereUniqueInput>>;
  create?: InputMaybe<Array<UtilityProgramMetadataKeyCreateInput>>;
  disconnect?: InputMaybe<Array<UtilityProgramMetadataKeyWhereUniqueInput>>;
  set?: InputMaybe<Array<UtilityProgramMetadataKeyWhereUniqueInput>>;
};

export type UtilityProgramMetadataKeyUpdateArgs = {
  data: UtilityProgramMetadataKeyUpdateInput;
  where: UtilityProgramMetadataKeyWhereUniqueInput;
};

export type UtilityProgramMetadataKeyUpdateInput = {
  key?: InputMaybe<Scalars['String']>;
  utilityProgram?: InputMaybe<UtilityProgramRelateToManyForUpdateInput>;
};

export type UtilityProgramMetadataKeyWhereInput = {
  AND?: InputMaybe<Array<UtilityProgramMetadataKeyWhereInput>>;
  NOT?: InputMaybe<Array<UtilityProgramMetadataKeyWhereInput>>;
  OR?: InputMaybe<Array<UtilityProgramMetadataKeyWhereInput>>;
  id?: InputMaybe<IdFilter>;
  key?: InputMaybe<StringFilter>;
  utilityProgram?: InputMaybe<UtilityProgramManyRelationFilter>;
};

export type UtilityProgramMetadataKeyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type UtilityProgramOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  sponsorName?: InputMaybe<OrderDirection>;
  useCmsViewConfig?: InputMaybe<OrderDirection>;
  utilityProgramId?: InputMaybe<OrderDirection>;
};

export type UtilityProgramRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UtilityProgramWhereUniqueInput>>;
  create?: InputMaybe<Array<UtilityProgramCreateInput>>;
};

export type UtilityProgramRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UtilityProgramWhereUniqueInput>>;
  create?: InputMaybe<Array<UtilityProgramCreateInput>>;
  disconnect?: InputMaybe<Array<UtilityProgramWhereUniqueInput>>;
  set?: InputMaybe<Array<UtilityProgramWhereUniqueInput>>;
};

export type UtilityProgramRelateToOneForCreateInput = {
  connect?: InputMaybe<UtilityProgramWhereUniqueInput>;
  create?: InputMaybe<UtilityProgramCreateInput>;
};

export type UtilityProgramRelateToOneForUpdateInput = {
  connect?: InputMaybe<UtilityProgramWhereUniqueInput>;
  create?: InputMaybe<UtilityProgramCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UtilityProgramUpdateArgs = {
  data: UtilityProgramUpdateInput;
  where: UtilityProgramWhereUniqueInput;
};

export type UtilityProgramUpdateInput = {
  baseViewConfig?: InputMaybe<ViewConfigRelateToOneForUpdateInput>;
  groups?: InputMaybe<GroupRelateToManyForUpdateInput>;
  metadataKey?: InputMaybe<UtilityProgramMetadataKeyRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
  sponsorName?: InputMaybe<Scalars['String']>;
  useCmsViewConfig?: InputMaybe<Scalars['Boolean']>;
  utilityProgramId?: InputMaybe<Scalars['Int']>;
};

export type UtilityProgramWhereInput = {
  AND?: InputMaybe<Array<UtilityProgramWhereInput>>;
  NOT?: InputMaybe<Array<UtilityProgramWhereInput>>;
  OR?: InputMaybe<Array<UtilityProgramWhereInput>>;
  baseViewConfig?: InputMaybe<ViewConfigWhereInput>;
  groups?: InputMaybe<GroupManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  metadataKey?: InputMaybe<UtilityProgramMetadataKeyManyRelationFilter>;
  name?: InputMaybe<StringFilter>;
  sponsorName?: InputMaybe<StringFilter>;
  useCmsViewConfig?: InputMaybe<BooleanFilter>;
  utilityProgramId?: InputMaybe<IntFilter>;
};

export type UtilityProgramWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  utilityProgramId?: InputMaybe<Scalars['Int']>;
};

export type ValueChip = {
  __typename?: 'ValueChip';
  id: Scalars['ID'];
  isGivingValue?: Maybe<Scalars['Boolean']>;
  valueChip?: Maybe<Scalars['String']>;
  valueChipKind?: Maybe<Scalars['String']>;
  valueChipText?: Maybe<Scalars['String']>;
  viewConfig?: Maybe<ViewConfig>;
};

export type ValueChipCreateInput = {
  isGivingValue?: InputMaybe<Scalars['Boolean']>;
  valueChip?: InputMaybe<Scalars['String']>;
  valueChipKind?: InputMaybe<Scalars['String']>;
  valueChipText?: InputMaybe<Scalars['String']>;
  viewConfig?: InputMaybe<ViewConfigRelateToOneForCreateInput>;
};

export type ValueChipData = {
  __typename?: 'ValueChipData';
  id?: Maybe<Scalars['ID']>;
  isGivingValue?: Maybe<Scalars['Boolean']>;
  valueChip?: Maybe<Scalars['String']>;
  valueChipKind?: Maybe<Scalars['String']>;
  valueChipText?: Maybe<Scalars['String']>;
};

export type ValueChipManyRelationFilter = {
  every?: InputMaybe<ValueChipWhereInput>;
  none?: InputMaybe<ValueChipWhereInput>;
  some?: InputMaybe<ValueChipWhereInput>;
};

export type ValueChipOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  isGivingValue?: InputMaybe<OrderDirection>;
  valueChip?: InputMaybe<OrderDirection>;
  valueChipKind?: InputMaybe<OrderDirection>;
  valueChipText?: InputMaybe<OrderDirection>;
};

export type ValueChipRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ValueChipWhereUniqueInput>>;
  create?: InputMaybe<Array<ValueChipCreateInput>>;
};

export type ValueChipRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ValueChipWhereUniqueInput>>;
  create?: InputMaybe<Array<ValueChipCreateInput>>;
  disconnect?: InputMaybe<Array<ValueChipWhereUniqueInput>>;
  set?: InputMaybe<Array<ValueChipWhereUniqueInput>>;
};

export type ValueChipUpdateArgs = {
  data: ValueChipUpdateInput;
  where: ValueChipWhereUniqueInput;
};

export type ValueChipUpdateInput = {
  isGivingValue?: InputMaybe<Scalars['Boolean']>;
  valueChip?: InputMaybe<Scalars['String']>;
  valueChipKind?: InputMaybe<Scalars['String']>;
  valueChipText?: InputMaybe<Scalars['String']>;
  viewConfig?: InputMaybe<ViewConfigRelateToOneForUpdateInput>;
};

export type ValueChipWhereInput = {
  AND?: InputMaybe<Array<ValueChipWhereInput>>;
  NOT?: InputMaybe<Array<ValueChipWhereInput>>;
  OR?: InputMaybe<Array<ValueChipWhereInput>>;
  id?: InputMaybe<IdFilter>;
  isGivingValue?: InputMaybe<BooleanFilter>;
  valueChip?: InputMaybe<StringFilter>;
  valueChipKind?: InputMaybe<StringFilter>;
  valueChipText?: InputMaybe<StringFilter>;
  viewConfig?: InputMaybe<ViewConfigWhereInput>;
};

export type ValueChipWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ViewConfig = {
  __typename?: 'ViewConfig';
  accentColor?: Maybe<Scalars['String']>;
  accentSubtleColor?: Maybe<Scalars['String']>;
  accountNumberEntryRequired?: Maybe<Scalars['Boolean']>;
  accountNumberLabel?: Maybe<Scalars['String']>;
  accountNumberLength?: Maybe<Scalars['Int']>;
  addressSelectionDescription?: Maybe<Scalars['String']>;
  addressSelectionTitle?: Maybe<Scalars['String']>;
  bannerLogo?: Maybe<ImageFieldOutput>;
  chargeForecastSubtitle?: Maybe<Scalars['String']>;
  chargerDashboardAlertContent?: Maybe<Scalars['String']>;
  customAppStoreUrl?: Maybe<Scalars['String']>;
  customPlayStoreUrl?: Maybe<Scalars['String']>;
  dashboardAlertContent?: Maybe<Scalars['String']>;
  disabledMessage?: Maybe<Scalars['String']>;
  disenrollDescription?: Maybe<Scalars['String']>;
  disenrollPreview?: Maybe<Scalars['String']>;
  disenrollPrimaryButtonText?: Maybe<Scalars['String']>;
  disenrollTitle?: Maybe<Scalars['String']>;
  editedFields?: Maybe<Scalars['JSON']>;
  enrollConfirmationDescription?: Maybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonBackgroundColor?: Maybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonColor?: Maybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonText?: Maybe<Scalars['String']>;
  enrollConfirmationTitle?: Maybe<Scalars['String']>;
  enrolledFunctionality?: Maybe<Scalars['JSON']>;
  enrollmentEndDate?: Maybe<Scalars['CalendarDay']>;
  eventOptOutMessageThermostat?: Maybe<Scalars['String']>;
  eventOptOutMessageVehicle?: Maybe<Scalars['String']>;
  eventOptOutMessageVehicleCharger?: Maybe<Scalars['String']>;
  externalContactDescription?: Maybe<Scalars['String']>;
  externalContactSections?: Maybe<Array<ExternalContactSection>>;
  externalContactSectionsCount?: Maybe<Scalars['Int']>;
  externalContactTitle?: Maybe<Scalars['String']>;
  faqUrl?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  homeMeters?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  includeAccountNumberEntry?: Maybe<Scalars['Boolean']>;
  learnMoreButtonTitle?: Maybe<Scalars['String']>;
  learnMorePreview?: Maybe<Scalars['String']>;
  learnMoreSubtitle?: Maybe<Scalars['String']>;
  learnMoreTitle?: Maybe<Scalars['String']>;
  levelThreeSubtitle?: Maybe<Scalars['String']>;
  levelThreeSummary?: Maybe<ViewConfig_LevelThreeSummary_Document>;
  logo?: Maybe<ImageFieldOutput>;
  name?: Maybe<Scalars['String']>;
  navigateTo?: Maybe<Scalars['String']>;
  offPeakChargingLabel?: Maybe<Scalars['String']>;
  onboardingButtonBackgroundColor?: Maybe<Scalars['String']>;
  onboardingButtonText?: Maybe<Scalars['String']>;
  onboardingButtonTextColor?: Maybe<Scalars['String']>;
  onboardingEligibleDevicesDescription?: Maybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonBackgroundColor?: Maybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonColor?: Maybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonText?: Maybe<Scalars['String']>;
  onboardingEligibleDevicesTitle?: Maybe<Scalars['String']>;
  onboardingFooter?: Maybe<Scalars['String']>;
  onboardingInformationList?: Maybe<Array<OnboardingInformationItem>>;
  onboardingInformationListCount?: Maybe<Scalars['Int']>;
  onboardingPreview?: Maybe<Scalars['String']>;
  onboardingProgramName?: Maybe<Scalars['String']>;
  onboardingSubtitle?: Maybe<Scalars['String']>;
  onboardingTitle?: Maybe<Scalars['String']>;
  parentBaseViewConfig?: Maybe<ViewConfig>;
  partnerDeviceEnrollmentDescription?: Maybe<Scalars['String']>;
  partnerIntegrationProgramName?: Maybe<Scalars['String']>;
  postApplicationDocument?: Maybe<ViewConfig_PostApplicationDocument_Document>;
  primaryColor?: Maybe<Scalars['String']>;
  primarySubtleColor?: Maybe<Scalars['String']>;
  referralBackgroundImage?: Maybe<ImageFieldOutput>;
  referralCodes?: Maybe<Scalars['String']>;
  referralDescription?: Maybe<Scalars['String']>;
  referralPreview?: Maybe<Scalars['String']>;
  referralProgramLogo?: Maybe<ImageFieldOutput>;
  referralShowTag?: Maybe<Scalars['Boolean']>;
  referralSubtitle?: Maybe<Scalars['String']>;
  referralTagText?: Maybe<Scalars['String']>;
  referralTitle?: Maybe<Scalars['String']>;
  requireHvacAttestation?: Maybe<Scalars['Boolean']>;
  residenceVerificationDescription?: Maybe<Scalars['String']>;
  residenceVerificationTitle?: Maybe<Scalars['String']>;
  rewardsInviteDescription?: Maybe<Scalars['String']>;
  rewardsInviteTitle?: Maybe<Scalars['String']>;
  rollingDeadline?: Maybe<Scalars['Boolean']>;
  savingsTagline?: Maybe<Scalars['String']>;
  scheduleChargingSubtitle?: Maybe<Scalars['String']>;
  schedulerDescription?: Maybe<Scalars['String']>;
  schedulerEnrolledAlert?: Maybe<Scalars['String']>;
  schedulerPreview?: Maybe<Scalars['String']>;
  schedulerTitle?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  secondaryLogo?: Maybe<ImageFieldOutput>;
  secondarySubtleColor?: Maybe<Scalars['String']>;
  shareLinkUrl?: Maybe<Scalars['String']>;
  showDisenrollConfirmation?: Maybe<Scalars['Boolean']>;
  showEnrollmentConfirmationModal?: Maybe<Scalars['Boolean']>;
  showScheduleChargingSubtitle?: Maybe<Scalars['Boolean']>;
  showTermsOfService?: Maybe<Scalars['Boolean']>;
  signupText?: Maybe<Scalars['String']>;
  termsOfService?: Maybe<ViewConfig_TermsOfService_Document>;
  thermostatDashboardAlertContent?: Maybe<Scalars['String']>;
  thermostatSaveMoneyAlert?: Maybe<Scalars['String']>;
  thermostats?: Maybe<Scalars['Boolean']>;
  tosUrl?: Maybe<Scalars['String']>;
  touCsl?: Maybe<Scalars['String']>;
  unenrollmentDeflection?: Maybe<Scalars['JSON']>;
  unenrollmentWarningText?: Maybe<Scalars['String']>;
  useMultiProgramFlow?: Maybe<Scalars['Boolean']>;
  utilityBillExampleImage?: Maybe<ImageFieldOutput>;
  utilityProgramConnectDescription?: Maybe<Scalars['String']>;
  utilityProgramConnectTitle?: Maybe<Scalars['String']>;
  valueChips?: Maybe<Array<ValueChip>>;
  valueChipsCount?: Maybe<Scalars['Int']>;
  vehicleChargers?: Maybe<Scalars['Boolean']>;
  vehicles?: Maybe<Scalars['Boolean']>;
};


export type ViewConfigExternalContactSectionsArgs = {
  cursor?: InputMaybe<ExternalContactSectionWhereUniqueInput>;
  orderBy?: Array<ExternalContactSectionOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ExternalContactSectionWhereInput;
};


export type ViewConfigExternalContactSectionsCountArgs = {
  where?: ExternalContactSectionWhereInput;
};


export type ViewConfigOnboardingInformationListArgs = {
  cursor?: InputMaybe<OnboardingInformationItemWhereUniqueInput>;
  orderBy?: Array<OnboardingInformationItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: OnboardingInformationItemWhereInput;
};


export type ViewConfigOnboardingInformationListCountArgs = {
  where?: OnboardingInformationItemWhereInput;
};


export type ViewConfigValueChipsArgs = {
  cursor?: InputMaybe<ValueChipWhereUniqueInput>;
  orderBy?: Array<ValueChipOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ValueChipWhereInput;
};


export type ViewConfigValueChipsCountArgs = {
  where?: ValueChipWhereInput;
};

export type ViewConfigButton = {
  __typename?: 'ViewConfigButton';
  backgroundColor?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ViewConfigCreateInput = {
  accentColor?: InputMaybe<Scalars['String']>;
  accentSubtleColor?: InputMaybe<Scalars['String']>;
  accountNumberEntryRequired?: InputMaybe<Scalars['Boolean']>;
  accountNumberLabel?: InputMaybe<Scalars['String']>;
  accountNumberLength?: InputMaybe<Scalars['Int']>;
  addressSelectionDescription?: InputMaybe<Scalars['String']>;
  addressSelectionTitle?: InputMaybe<Scalars['String']>;
  bannerLogo?: InputMaybe<ImageFieldInput>;
  chargeForecastSubtitle?: InputMaybe<Scalars['String']>;
  chargerDashboardAlertContent?: InputMaybe<Scalars['String']>;
  customAppStoreUrl?: InputMaybe<Scalars['String']>;
  customPlayStoreUrl?: InputMaybe<Scalars['String']>;
  dashboardAlertContent?: InputMaybe<Scalars['String']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  disenrollDescription?: InputMaybe<Scalars['String']>;
  disenrollPreview?: InputMaybe<Scalars['String']>;
  disenrollPrimaryButtonText?: InputMaybe<Scalars['String']>;
  disenrollTitle?: InputMaybe<Scalars['String']>;
  editedFields?: InputMaybe<Scalars['JSON']>;
  enrollConfirmationDescription?: InputMaybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonColor?: InputMaybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonText?: InputMaybe<Scalars['String']>;
  enrollConfirmationTitle?: InputMaybe<Scalars['String']>;
  enrolledFunctionality?: InputMaybe<Scalars['JSON']>;
  enrollmentEndDate?: InputMaybe<Scalars['CalendarDay']>;
  eventOptOutMessageThermostat?: InputMaybe<Scalars['String']>;
  eventOptOutMessageVehicle?: InputMaybe<Scalars['String']>;
  eventOptOutMessageVehicleCharger?: InputMaybe<Scalars['String']>;
  externalContactDescription?: InputMaybe<Scalars['String']>;
  externalContactSections?: InputMaybe<ExternalContactSectionRelateToManyForCreateInput>;
  externalContactTitle?: InputMaybe<Scalars['String']>;
  faqUrl?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<GroupRelateToOneForCreateInput>;
  homeMeters?: InputMaybe<Scalars['Boolean']>;
  includeAccountNumberEntry?: InputMaybe<Scalars['Boolean']>;
  learnMoreButtonTitle?: InputMaybe<Scalars['String']>;
  learnMorePreview?: InputMaybe<Scalars['String']>;
  learnMoreSubtitle?: InputMaybe<Scalars['String']>;
  learnMoreTitle?: InputMaybe<Scalars['String']>;
  levelThreeSubtitle?: InputMaybe<Scalars['String']>;
  levelThreeSummary?: InputMaybe<Scalars['JSON']>;
  logo?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  navigateTo?: InputMaybe<Scalars['String']>;
  offPeakChargingLabel?: InputMaybe<Scalars['String']>;
  onboardingButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  onboardingButtonText?: InputMaybe<Scalars['String']>;
  onboardingButtonTextColor?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesDescription?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonColor?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonText?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesTitle?: InputMaybe<Scalars['String']>;
  onboardingFooter?: InputMaybe<Scalars['String']>;
  onboardingInformationList?: InputMaybe<OnboardingInformationItemRelateToManyForCreateInput>;
  onboardingPreview?: InputMaybe<Scalars['String']>;
  onboardingProgramName?: InputMaybe<Scalars['String']>;
  onboardingSubtitle?: InputMaybe<Scalars['String']>;
  onboardingTitle?: InputMaybe<Scalars['String']>;
  partnerDeviceEnrollmentDescription?: InputMaybe<Scalars['String']>;
  partnerIntegrationProgramName?: InputMaybe<Scalars['String']>;
  postApplicationDocument?: InputMaybe<Scalars['JSON']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  primarySubtleColor?: InputMaybe<Scalars['String']>;
  referralBackgroundImage?: InputMaybe<ImageFieldInput>;
  referralCodes?: InputMaybe<Scalars['String']>;
  referralDescription?: InputMaybe<Scalars['String']>;
  referralPreview?: InputMaybe<Scalars['String']>;
  referralProgramLogo?: InputMaybe<ImageFieldInput>;
  referralShowTag?: InputMaybe<Scalars['Boolean']>;
  referralSubtitle?: InputMaybe<Scalars['String']>;
  referralTagText?: InputMaybe<Scalars['String']>;
  referralTitle?: InputMaybe<Scalars['String']>;
  requireHvacAttestation?: InputMaybe<Scalars['Boolean']>;
  residenceVerificationDescription?: InputMaybe<Scalars['String']>;
  residenceVerificationTitle?: InputMaybe<Scalars['String']>;
  rewardsInviteDescription?: InputMaybe<Scalars['String']>;
  rewardsInviteTitle?: InputMaybe<Scalars['String']>;
  rollingDeadline?: InputMaybe<Scalars['Boolean']>;
  savingsTagline?: InputMaybe<Scalars['String']>;
  scheduleChargingSubtitle?: InputMaybe<Scalars['String']>;
  schedulerDescription?: InputMaybe<Scalars['String']>;
  schedulerEnrolledAlert?: InputMaybe<Scalars['String']>;
  schedulerPreview?: InputMaybe<Scalars['String']>;
  schedulerTitle?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  secondaryLogo?: InputMaybe<ImageFieldInput>;
  secondarySubtleColor?: InputMaybe<Scalars['String']>;
  shareLinkUrl?: InputMaybe<Scalars['String']>;
  showDisenrollConfirmation?: InputMaybe<Scalars['Boolean']>;
  showEnrollmentConfirmationModal?: InputMaybe<Scalars['Boolean']>;
  showScheduleChargingSubtitle?: InputMaybe<Scalars['Boolean']>;
  showTermsOfService?: InputMaybe<Scalars['Boolean']>;
  signupText?: InputMaybe<Scalars['String']>;
  termsOfService?: InputMaybe<Scalars['JSON']>;
  thermostatDashboardAlertContent?: InputMaybe<Scalars['String']>;
  thermostatSaveMoneyAlert?: InputMaybe<Scalars['String']>;
  thermostats?: InputMaybe<Scalars['Boolean']>;
  tosUrl?: InputMaybe<Scalars['String']>;
  touCsl?: InputMaybe<Scalars['String']>;
  unenrollmentDeflection?: InputMaybe<Scalars['JSON']>;
  unenrollmentWarningText?: InputMaybe<Scalars['String']>;
  useMultiProgramFlow?: InputMaybe<Scalars['Boolean']>;
  utilityBillExampleImage?: InputMaybe<ImageFieldInput>;
  utilityProgramConnectDescription?: InputMaybe<Scalars['String']>;
  utilityProgramConnectTitle?: InputMaybe<Scalars['String']>;
  valueChips?: InputMaybe<ValueChipRelateToManyForCreateInput>;
  vehicleChargers?: InputMaybe<Scalars['Boolean']>;
  vehicles?: InputMaybe<Scalars['Boolean']>;
};

export type ViewConfigManyRelationFilter = {
  every?: InputMaybe<ViewConfigWhereInput>;
  none?: InputMaybe<ViewConfigWhereInput>;
  some?: InputMaybe<ViewConfigWhereInput>;
};

export type ViewConfigModal = {
  __typename?: 'ViewConfigModal';
  description: Scalars['String'];
  primaryButton?: Maybe<ViewConfigButton>;
  title: Scalars['String'];
};

export type ViewConfigOrderByInput = {
  accentColor?: InputMaybe<OrderDirection>;
  accentSubtleColor?: InputMaybe<OrderDirection>;
  accountNumberEntryRequired?: InputMaybe<OrderDirection>;
  accountNumberLabel?: InputMaybe<OrderDirection>;
  accountNumberLength?: InputMaybe<OrderDirection>;
  addressSelectionDescription?: InputMaybe<OrderDirection>;
  addressSelectionTitle?: InputMaybe<OrderDirection>;
  chargeForecastSubtitle?: InputMaybe<OrderDirection>;
  chargerDashboardAlertContent?: InputMaybe<OrderDirection>;
  customAppStoreUrl?: InputMaybe<OrderDirection>;
  customPlayStoreUrl?: InputMaybe<OrderDirection>;
  dashboardAlertContent?: InputMaybe<OrderDirection>;
  disabledMessage?: InputMaybe<OrderDirection>;
  disenrollDescription?: InputMaybe<OrderDirection>;
  disenrollPreview?: InputMaybe<OrderDirection>;
  disenrollPrimaryButtonText?: InputMaybe<OrderDirection>;
  disenrollTitle?: InputMaybe<OrderDirection>;
  enrollConfirmationDescription?: InputMaybe<OrderDirection>;
  enrollConfirmationPrimaryButtonBackgroundColor?: InputMaybe<OrderDirection>;
  enrollConfirmationPrimaryButtonColor?: InputMaybe<OrderDirection>;
  enrollConfirmationPrimaryButtonText?: InputMaybe<OrderDirection>;
  enrollConfirmationTitle?: InputMaybe<OrderDirection>;
  enrollmentEndDate?: InputMaybe<OrderDirection>;
  eventOptOutMessageThermostat?: InputMaybe<OrderDirection>;
  eventOptOutMessageVehicle?: InputMaybe<OrderDirection>;
  eventOptOutMessageVehicleCharger?: InputMaybe<OrderDirection>;
  externalContactDescription?: InputMaybe<OrderDirection>;
  externalContactTitle?: InputMaybe<OrderDirection>;
  faqUrl?: InputMaybe<OrderDirection>;
  homeMeters?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  includeAccountNumberEntry?: InputMaybe<OrderDirection>;
  learnMoreButtonTitle?: InputMaybe<OrderDirection>;
  learnMorePreview?: InputMaybe<OrderDirection>;
  learnMoreSubtitle?: InputMaybe<OrderDirection>;
  learnMoreTitle?: InputMaybe<OrderDirection>;
  levelThreeSubtitle?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  navigateTo?: InputMaybe<OrderDirection>;
  offPeakChargingLabel?: InputMaybe<OrderDirection>;
  onboardingButtonBackgroundColor?: InputMaybe<OrderDirection>;
  onboardingButtonText?: InputMaybe<OrderDirection>;
  onboardingButtonTextColor?: InputMaybe<OrderDirection>;
  onboardingEligibleDevicesDescription?: InputMaybe<OrderDirection>;
  onboardingEligibleDevicesPrimaryButtonBackgroundColor?: InputMaybe<OrderDirection>;
  onboardingEligibleDevicesPrimaryButtonColor?: InputMaybe<OrderDirection>;
  onboardingEligibleDevicesPrimaryButtonText?: InputMaybe<OrderDirection>;
  onboardingEligibleDevicesTitle?: InputMaybe<OrderDirection>;
  onboardingFooter?: InputMaybe<OrderDirection>;
  onboardingPreview?: InputMaybe<OrderDirection>;
  onboardingProgramName?: InputMaybe<OrderDirection>;
  onboardingSubtitle?: InputMaybe<OrderDirection>;
  onboardingTitle?: InputMaybe<OrderDirection>;
  partnerDeviceEnrollmentDescription?: InputMaybe<OrderDirection>;
  partnerIntegrationProgramName?: InputMaybe<OrderDirection>;
  primaryColor?: InputMaybe<OrderDirection>;
  primarySubtleColor?: InputMaybe<OrderDirection>;
  referralCodes?: InputMaybe<OrderDirection>;
  referralDescription?: InputMaybe<OrderDirection>;
  referralPreview?: InputMaybe<OrderDirection>;
  referralShowTag?: InputMaybe<OrderDirection>;
  referralSubtitle?: InputMaybe<OrderDirection>;
  referralTagText?: InputMaybe<OrderDirection>;
  referralTitle?: InputMaybe<OrderDirection>;
  requireHvacAttestation?: InputMaybe<OrderDirection>;
  residenceVerificationDescription?: InputMaybe<OrderDirection>;
  residenceVerificationTitle?: InputMaybe<OrderDirection>;
  rewardsInviteDescription?: InputMaybe<OrderDirection>;
  rewardsInviteTitle?: InputMaybe<OrderDirection>;
  rollingDeadline?: InputMaybe<OrderDirection>;
  savingsTagline?: InputMaybe<OrderDirection>;
  scheduleChargingSubtitle?: InputMaybe<OrderDirection>;
  schedulerDescription?: InputMaybe<OrderDirection>;
  schedulerEnrolledAlert?: InputMaybe<OrderDirection>;
  schedulerPreview?: InputMaybe<OrderDirection>;
  schedulerTitle?: InputMaybe<OrderDirection>;
  secondaryColor?: InputMaybe<OrderDirection>;
  secondarySubtleColor?: InputMaybe<OrderDirection>;
  shareLinkUrl?: InputMaybe<OrderDirection>;
  showDisenrollConfirmation?: InputMaybe<OrderDirection>;
  showEnrollmentConfirmationModal?: InputMaybe<OrderDirection>;
  showScheduleChargingSubtitle?: InputMaybe<OrderDirection>;
  showTermsOfService?: InputMaybe<OrderDirection>;
  signupText?: InputMaybe<OrderDirection>;
  thermostatDashboardAlertContent?: InputMaybe<OrderDirection>;
  thermostatSaveMoneyAlert?: InputMaybe<OrderDirection>;
  thermostats?: InputMaybe<OrderDirection>;
  tosUrl?: InputMaybe<OrderDirection>;
  touCsl?: InputMaybe<OrderDirection>;
  unenrollmentWarningText?: InputMaybe<OrderDirection>;
  useMultiProgramFlow?: InputMaybe<OrderDirection>;
  utilityProgramConnectDescription?: InputMaybe<OrderDirection>;
  utilityProgramConnectTitle?: InputMaybe<OrderDirection>;
  vehicleChargers?: InputMaybe<OrderDirection>;
  vehicles?: InputMaybe<OrderDirection>;
};

export type ViewConfigRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ViewConfigWhereUniqueInput>>;
  create?: InputMaybe<Array<ViewConfigCreateInput>>;
};

export type ViewConfigRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ViewConfigWhereUniqueInput>>;
  create?: InputMaybe<Array<ViewConfigCreateInput>>;
  disconnect?: InputMaybe<Array<ViewConfigWhereUniqueInput>>;
  set?: InputMaybe<Array<ViewConfigWhereUniqueInput>>;
};

export type ViewConfigRelateToOneForCreateInput = {
  connect?: InputMaybe<ViewConfigWhereUniqueInput>;
  create?: InputMaybe<ViewConfigCreateInput>;
};

export type ViewConfigRelateToOneForUpdateInput = {
  connect?: InputMaybe<ViewConfigWhereUniqueInput>;
  create?: InputMaybe<ViewConfigCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type ViewConfigText = {
  __typename?: 'ViewConfigText';
  color?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ViewConfigUpdateArgs = {
  data: ViewConfigUpdateInput;
  where: ViewConfigWhereUniqueInput;
};

export type ViewConfigUpdateInput = {
  accentColor?: InputMaybe<Scalars['String']>;
  accentSubtleColor?: InputMaybe<Scalars['String']>;
  accountNumberEntryRequired?: InputMaybe<Scalars['Boolean']>;
  accountNumberLabel?: InputMaybe<Scalars['String']>;
  accountNumberLength?: InputMaybe<Scalars['Int']>;
  addressSelectionDescription?: InputMaybe<Scalars['String']>;
  addressSelectionTitle?: InputMaybe<Scalars['String']>;
  bannerLogo?: InputMaybe<ImageFieldInput>;
  chargeForecastSubtitle?: InputMaybe<Scalars['String']>;
  chargerDashboardAlertContent?: InputMaybe<Scalars['String']>;
  customAppStoreUrl?: InputMaybe<Scalars['String']>;
  customPlayStoreUrl?: InputMaybe<Scalars['String']>;
  dashboardAlertContent?: InputMaybe<Scalars['String']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  disenrollDescription?: InputMaybe<Scalars['String']>;
  disenrollPreview?: InputMaybe<Scalars['String']>;
  disenrollPrimaryButtonText?: InputMaybe<Scalars['String']>;
  disenrollTitle?: InputMaybe<Scalars['String']>;
  editedFields?: InputMaybe<Scalars['JSON']>;
  enrollConfirmationDescription?: InputMaybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonColor?: InputMaybe<Scalars['String']>;
  enrollConfirmationPrimaryButtonText?: InputMaybe<Scalars['String']>;
  enrollConfirmationTitle?: InputMaybe<Scalars['String']>;
  enrolledFunctionality?: InputMaybe<Scalars['JSON']>;
  enrollmentEndDate?: InputMaybe<Scalars['CalendarDay']>;
  eventOptOutMessageThermostat?: InputMaybe<Scalars['String']>;
  eventOptOutMessageVehicle?: InputMaybe<Scalars['String']>;
  eventOptOutMessageVehicleCharger?: InputMaybe<Scalars['String']>;
  externalContactDescription?: InputMaybe<Scalars['String']>;
  externalContactSections?: InputMaybe<ExternalContactSectionRelateToManyForUpdateInput>;
  externalContactTitle?: InputMaybe<Scalars['String']>;
  faqUrl?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<GroupRelateToOneForUpdateInput>;
  homeMeters?: InputMaybe<Scalars['Boolean']>;
  includeAccountNumberEntry?: InputMaybe<Scalars['Boolean']>;
  learnMoreButtonTitle?: InputMaybe<Scalars['String']>;
  learnMorePreview?: InputMaybe<Scalars['String']>;
  learnMoreSubtitle?: InputMaybe<Scalars['String']>;
  learnMoreTitle?: InputMaybe<Scalars['String']>;
  levelThreeSubtitle?: InputMaybe<Scalars['String']>;
  levelThreeSummary?: InputMaybe<Scalars['JSON']>;
  logo?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  navigateTo?: InputMaybe<Scalars['String']>;
  offPeakChargingLabel?: InputMaybe<Scalars['String']>;
  onboardingButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  onboardingButtonText?: InputMaybe<Scalars['String']>;
  onboardingButtonTextColor?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesDescription?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonColor?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesPrimaryButtonText?: InputMaybe<Scalars['String']>;
  onboardingEligibleDevicesTitle?: InputMaybe<Scalars['String']>;
  onboardingFooter?: InputMaybe<Scalars['String']>;
  onboardingInformationList?: InputMaybe<OnboardingInformationItemRelateToManyForUpdateInput>;
  onboardingPreview?: InputMaybe<Scalars['String']>;
  onboardingProgramName?: InputMaybe<Scalars['String']>;
  onboardingSubtitle?: InputMaybe<Scalars['String']>;
  onboardingTitle?: InputMaybe<Scalars['String']>;
  partnerDeviceEnrollmentDescription?: InputMaybe<Scalars['String']>;
  partnerIntegrationProgramName?: InputMaybe<Scalars['String']>;
  postApplicationDocument?: InputMaybe<Scalars['JSON']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  primarySubtleColor?: InputMaybe<Scalars['String']>;
  referralBackgroundImage?: InputMaybe<ImageFieldInput>;
  referralCodes?: InputMaybe<Scalars['String']>;
  referralDescription?: InputMaybe<Scalars['String']>;
  referralPreview?: InputMaybe<Scalars['String']>;
  referralProgramLogo?: InputMaybe<ImageFieldInput>;
  referralShowTag?: InputMaybe<Scalars['Boolean']>;
  referralSubtitle?: InputMaybe<Scalars['String']>;
  referralTagText?: InputMaybe<Scalars['String']>;
  referralTitle?: InputMaybe<Scalars['String']>;
  requireHvacAttestation?: InputMaybe<Scalars['Boolean']>;
  residenceVerificationDescription?: InputMaybe<Scalars['String']>;
  residenceVerificationTitle?: InputMaybe<Scalars['String']>;
  rewardsInviteDescription?: InputMaybe<Scalars['String']>;
  rewardsInviteTitle?: InputMaybe<Scalars['String']>;
  rollingDeadline?: InputMaybe<Scalars['Boolean']>;
  savingsTagline?: InputMaybe<Scalars['String']>;
  scheduleChargingSubtitle?: InputMaybe<Scalars['String']>;
  schedulerDescription?: InputMaybe<Scalars['String']>;
  schedulerEnrolledAlert?: InputMaybe<Scalars['String']>;
  schedulerPreview?: InputMaybe<Scalars['String']>;
  schedulerTitle?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  secondaryLogo?: InputMaybe<ImageFieldInput>;
  secondarySubtleColor?: InputMaybe<Scalars['String']>;
  shareLinkUrl?: InputMaybe<Scalars['String']>;
  showDisenrollConfirmation?: InputMaybe<Scalars['Boolean']>;
  showEnrollmentConfirmationModal?: InputMaybe<Scalars['Boolean']>;
  showScheduleChargingSubtitle?: InputMaybe<Scalars['Boolean']>;
  showTermsOfService?: InputMaybe<Scalars['Boolean']>;
  signupText?: InputMaybe<Scalars['String']>;
  termsOfService?: InputMaybe<Scalars['JSON']>;
  thermostatDashboardAlertContent?: InputMaybe<Scalars['String']>;
  thermostatSaveMoneyAlert?: InputMaybe<Scalars['String']>;
  thermostats?: InputMaybe<Scalars['Boolean']>;
  tosUrl?: InputMaybe<Scalars['String']>;
  touCsl?: InputMaybe<Scalars['String']>;
  unenrollmentDeflection?: InputMaybe<Scalars['JSON']>;
  unenrollmentWarningText?: InputMaybe<Scalars['String']>;
  useMultiProgramFlow?: InputMaybe<Scalars['Boolean']>;
  utilityBillExampleImage?: InputMaybe<ImageFieldInput>;
  utilityProgramConnectDescription?: InputMaybe<Scalars['String']>;
  utilityProgramConnectTitle?: InputMaybe<Scalars['String']>;
  valueChips?: InputMaybe<ValueChipRelateToManyForUpdateInput>;
  vehicleChargers?: InputMaybe<Scalars['Boolean']>;
  vehicles?: InputMaybe<Scalars['Boolean']>;
};

export type ViewConfigWhereInput = {
  AND?: InputMaybe<Array<ViewConfigWhereInput>>;
  NOT?: InputMaybe<Array<ViewConfigWhereInput>>;
  OR?: InputMaybe<Array<ViewConfigWhereInput>>;
  accountNumberEntryRequired?: InputMaybe<BooleanFilter>;
  accountNumberLabel?: InputMaybe<StringFilter>;
  accountNumberLength?: InputMaybe<IntNullableFilter>;
  addressSelectionDescription?: InputMaybe<StringFilter>;
  addressSelectionTitle?: InputMaybe<StringFilter>;
  chargeForecastSubtitle?: InputMaybe<StringFilter>;
  chargerDashboardAlertContent?: InputMaybe<StringNullableFilter>;
  customAppStoreUrl?: InputMaybe<StringFilter>;
  customPlayStoreUrl?: InputMaybe<StringFilter>;
  dashboardAlertContent?: InputMaybe<StringNullableFilter>;
  disabledMessage?: InputMaybe<StringFilter>;
  disenrollDescription?: InputMaybe<StringNullableFilter>;
  disenrollPrimaryButtonText?: InputMaybe<StringNullableFilter>;
  disenrollTitle?: InputMaybe<StringNullableFilter>;
  enrollConfirmationDescription?: InputMaybe<StringFilter>;
  enrollConfirmationPrimaryButtonText?: InputMaybe<StringFilter>;
  enrollConfirmationTitle?: InputMaybe<StringFilter>;
  enrollmentEndDate?: InputMaybe<CalendarDayNullableFilter>;
  eventOptOutMessageThermostat?: InputMaybe<StringNullableFilter>;
  eventOptOutMessageVehicle?: InputMaybe<StringNullableFilter>;
  eventOptOutMessageVehicleCharger?: InputMaybe<StringNullableFilter>;
  externalContactDescription?: InputMaybe<StringFilter>;
  externalContactSections?: InputMaybe<ExternalContactSectionManyRelationFilter>;
  externalContactTitle?: InputMaybe<StringFilter>;
  faqUrl?: InputMaybe<StringFilter>;
  group?: InputMaybe<GroupWhereInput>;
  homeMeters?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IdFilter>;
  includeAccountNumberEntry?: InputMaybe<BooleanFilter>;
  learnMoreButtonTitle?: InputMaybe<StringFilter>;
  learnMoreSubtitle?: InputMaybe<StringFilter>;
  learnMoreTitle?: InputMaybe<StringFilter>;
  levelThreeSubtitle?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  navigateTo?: InputMaybe<StringFilter>;
  offPeakChargingLabel?: InputMaybe<StringFilter>;
  onboardingButtonText?: InputMaybe<StringNullableFilter>;
  onboardingEligibleDevicesDescription?: InputMaybe<StringNullableFilter>;
  onboardingEligibleDevicesPrimaryButtonText?: InputMaybe<StringNullableFilter>;
  onboardingEligibleDevicesTitle?: InputMaybe<StringNullableFilter>;
  onboardingFooter?: InputMaybe<StringFilter>;
  onboardingInformationList?: InputMaybe<OnboardingInformationItemManyRelationFilter>;
  onboardingProgramName?: InputMaybe<StringFilter>;
  onboardingSubtitle?: InputMaybe<StringFilter>;
  onboardingTitle?: InputMaybe<StringFilter>;
  partnerDeviceEnrollmentDescription?: InputMaybe<StringFilter>;
  partnerIntegrationProgramName?: InputMaybe<StringFilter>;
  referralCodes?: InputMaybe<StringFilter>;
  referralDescription?: InputMaybe<StringFilter>;
  referralShowTag?: InputMaybe<BooleanFilter>;
  referralSubtitle?: InputMaybe<StringNullableFilter>;
  referralTagText?: InputMaybe<StringFilter>;
  referralTitle?: InputMaybe<StringFilter>;
  requireHvacAttestation?: InputMaybe<BooleanFilter>;
  residenceVerificationDescription?: InputMaybe<StringFilter>;
  residenceVerificationTitle?: InputMaybe<StringFilter>;
  rewardsInviteDescription?: InputMaybe<StringFilter>;
  rewardsInviteTitle?: InputMaybe<StringFilter>;
  rollingDeadline?: InputMaybe<BooleanFilter>;
  savingsTagline?: InputMaybe<StringFilter>;
  scheduleChargingSubtitle?: InputMaybe<StringFilter>;
  schedulerDescription?: InputMaybe<StringFilter>;
  schedulerEnrolledAlert?: InputMaybe<StringNullableFilter>;
  schedulerTitle?: InputMaybe<StringFilter>;
  shareLinkUrl?: InputMaybe<StringFilter>;
  showDisenrollConfirmation?: InputMaybe<BooleanFilter>;
  showEnrollmentConfirmationModal?: InputMaybe<BooleanFilter>;
  showScheduleChargingSubtitle?: InputMaybe<BooleanFilter>;
  showTermsOfService?: InputMaybe<BooleanFilter>;
  signupText?: InputMaybe<StringFilter>;
  thermostatDashboardAlertContent?: InputMaybe<StringNullableFilter>;
  thermostatSaveMoneyAlert?: InputMaybe<StringNullableFilter>;
  thermostats?: InputMaybe<BooleanFilter>;
  tosUrl?: InputMaybe<StringFilter>;
  touCsl?: InputMaybe<StringFilter>;
  unenrollmentWarningText?: InputMaybe<StringNullableFilter>;
  useMultiProgramFlow?: InputMaybe<BooleanFilter>;
  utilityProgramConnectDescription?: InputMaybe<StringFilter>;
  utilityProgramConnectTitle?: InputMaybe<StringFilter>;
  valueChips?: InputMaybe<ValueChipManyRelationFilter>;
  vehicleChargers?: InputMaybe<BooleanFilter>;
  vehicles?: InputMaybe<BooleanFilter>;
};

export type ViewConfigWhereUniqueInput = {
  group?: InputMaybe<GroupWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']>;
};

export type ViewConfig_LevelThreeSummary_Document = {
  __typename?: 'ViewConfig_levelThreeSummary_Document';
  document: Scalars['JSON'];
};


export type ViewConfig_LevelThreeSummary_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type ViewConfig_PostApplicationDocument_Document = {
  __typename?: 'ViewConfig_postApplicationDocument_Document';
  document: Scalars['JSON'];
};


export type ViewConfig_PostApplicationDocument_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type ViewConfig_TermsOfService_Document = {
  __typename?: 'ViewConfig_termsOfService_Document';
  document: Scalars['JSON'];
};


export type ViewConfig_TermsOfService_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type FaqQueryVariables = Exact<{
  where: FaqWhereUniqueInput;
  orderBy: Array<FaqItemOrderByInput> | FaqItemOrderByInput;
}>;


export type FaqQuery = { __typename?: 'Query', fAQ?: { __typename?: 'FAQ', slug?: string | undefined, title?: string | undefined, subtitle?: { __typename?: 'FAQ_subtitle_Document', document: any } | undefined, items?: Array<{ __typename?: 'FAQItem', question?: string | undefined, answer?: { __typename?: 'FAQItem_answer_Document', document: any } | undefined }> | undefined } | undefined };

export type UtilitiesQueryVariables = Exact<{
  utilityProgramId: Scalars['ID'];
  utilityProgramIdInt: Scalars['Int'];
  groupName?: InputMaybe<Scalars['String']>;
}>;


export type UtilitiesQuery = { __typename?: 'Query', utilityProgram?: { __typename?: 'UtilityProgram', sponsorName?: string | undefined } | undefined, resolvedGroupViewConfig?: { __typename?: 'TransformedViewConfig', name?: string | undefined, enrolledFunctionality?: any | undefined, faqUrl?: string | undefined, tosUrl?: string | undefined, tosDocument?: any | undefined, logoUrl?: string | undefined, customPlayStoreUrl?: string | undefined, customAppStoreUrl?: string | undefined, bannerLogoUrl?: string | undefined, secondaryLogoUrl?: string | undefined, rewardsInviteTitle?: string | undefined, rewardsInviteDescription?: string | undefined, useMultiProgramFlow: boolean, postApplicationDocument?: any | undefined, thermostatSaveMoneyAlert?: string | undefined, unenrollmentWarningText?: string | undefined, dashboard?: { __typename?: 'DashboardConfig', alertHeaderContent?: string | undefined, thermostatAlertHeaderContent?: string | undefined, chargerAlertHeaderContent?: string | undefined } | undefined, chargeForecast?: { __typename?: 'ChargeForecastConfig', subtitle: string } | undefined, faq?: { __typename?: 'FaqConfig', slug: string } | undefined, learnMore: { __typename?: 'LearnMoreViewConfig', title: string, subtitle: string, buttonTitle: string, navigateTo?: string | undefined }, onboarding: { __typename?: 'OnboardingViewConfig', excludeHeaderAnimation?: boolean | undefined, title: string, subtitle: string, programName: string, footer?: string | undefined, informationList: any, primaryButton?: { __typename?: 'ViewConfigButton', backgroundColor?: string | undefined, color?: string | undefined, text?: string | undefined } | undefined, enrollConfirmation?: { __typename?: 'ViewConfigModal', title: string, description: string } | undefined }, referral: { __typename?: 'ReferralConfig', referralCodes: any, programLogoUrl: string, tagText?: string | undefined, showTag?: boolean | undefined, title: string, subtitle: string, description: string, backgroundImageUrl?: string | undefined }, scheduler: { __typename?: 'SchedulerViewConfig', title: string, description: string, enrolledAlert?: string | undefined, button?: { __typename?: 'ViewConfigButton', backgroundColor?: string | undefined, color?: string | undefined, text?: string | undefined } | undefined, disenrollConfirmation?: { __typename?: 'ViewConfigModal', title: string, description: string, primaryButton?: { __typename?: 'ViewConfigButton', text?: string | undefined } | undefined } | undefined }, utilityProgramConnect?: { __typename?: 'UtilityProgramConnectViewConfig', success: { __typename?: 'SuccessViewConfig', title?: string | undefined, description?: string | undefined } } | undefined, eligibleDeviceEnrollment?: { __typename?: 'EligibleDeviceEnrollmentConfig', title?: { __typename?: 'ViewConfigText', text?: string | undefined, color?: string | undefined } | undefined, description?: { __typename?: 'ViewConfigText', text?: string | undefined, color?: string | undefined } | undefined, enrollButton?: { __typename?: 'ViewConfigButton', backgroundColor?: string | undefined, color?: string | undefined, text?: string | undefined } | undefined } | undefined, enrollmentConfirmationModal?: { __typename?: 'EnrollConfirmationModal', title?: string | undefined, description?: string | undefined, tosDocument?: any | undefined } | undefined, scheduleCharging?: { __typename?: 'ScheduleCharging', subtitle?: string | undefined } | undefined, accountNumberEntry?: { __typename?: 'AccountNumberEntry', includeAccountNumberEntry?: boolean | undefined, accountNumberEntryRequired?: boolean | undefined, accountNumberLabel?: string | undefined, accountNumberLength?: number | undefined, utilityBillExampleImage?: string | undefined } | undefined, externalPartnerIntegration?: { __typename?: 'ExternalPartnerIntegrationConfig', programName: string, deviceEnrollmentDescription: string } | undefined, hvacAttestation?: { __typename?: 'HvacAttestationConfig', requireHvacAttestation?: boolean | undefined } | undefined, colorScheme?: { __typename?: 'ColorSchemeConfig', primaryColor?: string | undefined, primarySubtleColor?: string | undefined, secondaryColor?: string | undefined, secondarySubtleColor?: string | undefined, accentColor?: string | undefined, accentSubtleColor?: string | undefined } | undefined, disabledDevices?: { __typename?: 'DisabledDevicesConfig', vehicles?: boolean | undefined, thermostats?: boolean | undefined, vehicleChargers?: boolean | undefined, homeMeters?: boolean | undefined, disabledMessage?: string | undefined } | undefined, addressSelection?: { __typename?: 'AddressSelectionConfig', title?: string | undefined, description?: string | undefined } | undefined, residenceVerification?: { __typename?: 'ResidenceVerificationConfig', title?: string | undefined, description?: string | undefined } | undefined, externalContact?: { __typename?: 'ExternalContactConfig', title?: string | undefined, description?: string | undefined, sections?: Array<{ __typename?: 'ExternalContactSectionResolved', title?: string | undefined, site?: string | undefined, phone?: string | undefined, email?: string | undefined } | undefined> | undefined } | undefined, programCard?: { __typename?: 'ProgramCardConfig', enrollmentEndDate?: any | undefined, shareLinkUrl?: string | undefined, savingsTagline?: string | undefined, rollingDeadline?: boolean | undefined, offPeakChargingLabel?: string | undefined } | undefined, signupPage?: { __typename?: 'SignupPageConfig', signupText?: string | undefined } | undefined, levelThreeConfig?: { __typename?: 'LevelThreeConfig', levelThreeSubtitle?: string | undefined, levelThreeSummary?: any | undefined, valueChips?: Array<{ __typename?: 'ValueChipData', valueChipKind?: string | undefined, valueChipText?: string | undefined, isGivingValue?: boolean | undefined } | undefined> | undefined } | undefined, homeEnergyPreview?: { __typename?: 'HomeEnergyPreviewConfig', touCsl?: string | undefined } | undefined, eventOptOutMessage?: { __typename?: 'EventOptOutMessageConfig', thermostat?: string | undefined, vehicle?: string | undefined, vehicleCharger?: string | undefined } | undefined, unenrollmentDeflection?: Array<{ __typename?: 'UnenrollmentDeflectionEntry', articleUrl: string, articleText?: string | undefined, device: string, reasons: Array<string> } | undefined> | undefined } | undefined };


export const FaqDocument = gql`
    query Faq($where: FAQWhereUniqueInput!, $orderBy: [FAQItemOrderByInput!]!) {
  fAQ(where: $where) {
    slug
    subtitle {
      document
    }
    title
    items(orderBy: $orderBy) {
      question
      answer {
        document
      }
    }
  }
}
    `;

/**
 * __useFaqQuery__
 *
 * To run a query within a React component, call `useFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFaqQuery(baseOptions: Apollo.QueryHookOptions<FaqQuery, FaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqQuery, FaqQueryVariables>(FaqDocument, options);
      }
export function useFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqQuery, FaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqQuery, FaqQueryVariables>(FaqDocument, options);
        }
export type FaqQueryHookResult = ReturnType<typeof useFaqQuery>;
export type FaqLazyQueryHookResult = ReturnType<typeof useFaqLazyQuery>;
export type FaqQueryResult = Apollo.QueryResult<FaqQuery, FaqQueryVariables>;
export const UtilitiesDocument = gql`
    query Utilities($utilityProgramId: ID!, $utilityProgramIdInt: Int!, $groupName: String) {
  utilityProgram(where: {utilityProgramId: $utilityProgramIdInt}) {
    sponsorName
  }
  resolvedGroupViewConfig(
    utilityProgramId: $utilityProgramId
    groupName: $groupName
  ) {
    name
    dashboard {
      alertHeaderContent
      thermostatAlertHeaderContent
      chargerAlertHeaderContent
    }
    chargeForecast {
      subtitle
    }
    enrolledFunctionality
    faq {
      slug
    }
    learnMore {
      title
      subtitle
      buttonTitle
      navigateTo
    }
    onboarding {
      excludeHeaderAnimation
      title
      subtitle
      programName
      primaryButton {
        backgroundColor
        color
        text
      }
      footer
      informationList
      enrollConfirmation {
        title
        description
      }
    }
    referral {
      referralCodes
      programLogoUrl
      tagText
      showTag
      title
      subtitle
      description
      backgroundImageUrl
    }
    scheduler {
      title
      description
      button {
        backgroundColor
        color
        text
      }
      enrolledAlert
      disenrollConfirmation {
        title
        description
        primaryButton {
          text
        }
      }
    }
    utilityProgramConnect {
      success {
        title
        description
      }
    }
    eligibleDeviceEnrollment {
      title {
        text
        color
      }
      description {
        text
        color
      }
      enrollButton {
        backgroundColor
        color
        text
      }
    }
    enrollmentConfirmationModal {
      title
      description
      tosDocument
    }
    scheduleCharging {
      subtitle
    }
    accountNumberEntry {
      includeAccountNumberEntry
      accountNumberEntryRequired
      accountNumberLabel
      accountNumberLength
      utilityBillExampleImage
    }
    externalPartnerIntegration {
      programName
      deviceEnrollmentDescription
    }
    hvacAttestation {
      requireHvacAttestation
    }
    faqUrl
    tosUrl
    tosDocument
    logoUrl
    customPlayStoreUrl
    customAppStoreUrl
    colorScheme {
      primaryColor
      primarySubtleColor
      secondaryColor
      secondarySubtleColor
      accentColor
      accentSubtleColor
    }
    disabledDevices {
      vehicles
      thermostats
      vehicleChargers
      homeMeters
      disabledMessage
    }
    addressSelection {
      title
      description
    }
    bannerLogoUrl
    secondaryLogoUrl
    residenceVerification {
      title
      description
    }
    externalContact {
      title
      description
      sections {
        title
        site
        phone
        email
      }
    }
    programCard {
      enrollmentEndDate
      shareLinkUrl
      savingsTagline
      rollingDeadline
      offPeakChargingLabel
    }
    rewardsInviteTitle
    rewardsInviteDescription
    signupPage {
      signupText
    }
    levelThreeConfig {
      levelThreeSubtitle
      levelThreeSummary
      valueChips {
        valueChipKind
        valueChipText
        isGivingValue
      }
    }
    levelThreeConfig {
      levelThreeSubtitle
      levelThreeSummary
      valueChips {
        valueChipKind
        valueChipText
        isGivingValue
      }
    }
    homeEnergyPreview {
      touCsl
    }
    eventOptOutMessage {
      thermostat
      vehicle
      vehicleCharger
    }
    useMultiProgramFlow
    postApplicationDocument
    thermostatSaveMoneyAlert
    unenrollmentDeflection {
      articleUrl
      articleText
      device
      reasons
    }
    unenrollmentWarningText
  }
}
    `;

/**
 * __useUtilitiesQuery__
 *
 * To run a query within a React component, call `useUtilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilitiesQuery({
 *   variables: {
 *      utilityProgramId: // value for 'utilityProgramId'
 *      utilityProgramIdInt: // value for 'utilityProgramIdInt'
 *      groupName: // value for 'groupName'
 *   },
 * });
 */
export function useUtilitiesQuery(baseOptions: Apollo.QueryHookOptions<UtilitiesQuery, UtilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UtilitiesQuery, UtilitiesQueryVariables>(UtilitiesDocument, options);
      }
export function useUtilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UtilitiesQuery, UtilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UtilitiesQuery, UtilitiesQueryVariables>(UtilitiesDocument, options);
        }
export type UtilitiesQueryHookResult = ReturnType<typeof useUtilitiesQuery>;
export type UtilitiesLazyQueryHookResult = ReturnType<typeof useUtilitiesLazyQuery>;
export type UtilitiesQueryResult = Apollo.QueryResult<UtilitiesQuery, UtilitiesQueryVariables>;